// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes admin-panel-view-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes admin-panel-slide-in {
  from {
    opacity: 0;
    transform: translateX(16px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes admin-panel-toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes admin-panel-pulse {
  from {
    opacity: 0.35;
  }
  to {
    opacity: 0.75;
  }
}
@keyframes admin-panel-progress {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(260%);
  }
}
.admin-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  z-index: 50;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel--open {
  opacity: 1;
}
.admin-panel * {
  box-sizing: border-box;
}
.admin-panel h2, .admin-panel h3, .admin-panel h4, .admin-panel p, .admin-panel ul, .admin-panel dl, .admin-panel dd {
  margin: 0;
  padding: 0;
}
.admin-panel ul {
  list-style: none;
}
.admin-panel__sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.admin-panel__icon {
  flex: none;
  display: block;
}
.admin-panel__window {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  backdrop-filter: none;
  background: rgba(11, 15, 19, 0.985);
  position: relative;
  width: 92%;
  height: 90%;
  max-width: 2200px;
  display: grid;
  grid-template-columns: 232px minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  transform: translateY(12px) scale(0.985);
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__window * {
  box-sizing: border-box;
}
.admin-panel--open .admin-panel__window {
  transform: none;
}
.admin-panel__progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  overflow: hidden;
  z-index: 30;
  opacity: 0;
  transition: opacity 0.15s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: none;
}
.admin-panel__progress--on {
  opacity: 1;
}
.admin-panel__progress-bar {
  display: block;
  width: 38%;
  height: 100%;
  background: var(--gold-main);
  animation: admin-panel-progress 1.1s linear infinite;
}
.admin-panel__top {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 24px 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__brand {
  flex: none;
  width: 192px;
  padding-left: 8px;
}
.admin-panel__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  white-space: nowrap;
}
.admin-panel__gsearch {
  position: relative;
  flex: 1 1 280px;
  min-width: 160px;
  max-width: 480px;
}
.admin-panel__gsearch-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  margin-top: -8px;
  color: #8d8a82;
  pointer-events: none;
}
.admin-panel__gsearch .admin-panel__search-input {
  width: 100%;
  padding-left: 36px;
  padding-right: 36px;
}
.admin-panel__kbd {
  position: absolute;
  top: 50%;
  right: 8px;
  margin-top: -10px;
  min-width: 20px;
  padding: 1px 6px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #8d8a82;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  pointer-events: none;
}
.admin-panel__search-results {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 8px;
  padding: 4px;
  z-index: 20;
  max-height: 420px;
  overflow-y: auto;
}
.admin-panel__search-results * {
  box-sizing: border-box;
}
.admin-panel__search-empty {
  padding: 12px;
  color: #8d8a82;
  font-size: 14px;
}
.admin-panel__search-hit {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}
.admin-panel__search-hit--active {
  background: rgba(255, 255, 255, 0.1);
}
.admin-panel__pills {
  display: flex;
  align-items: center;
  flex: none;
}
.admin-panel__pill {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  padding: 0 12px;
  white-space: nowrap;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__pill:first-child {
  border-left: 0;
}
.admin-panel__pill--alert .admin-panel__pill-value {
  color: #d9786d;
}
.admin-panel__pill-label {
  font-size: 12px;
  font-weight: 600;
  color: #8d8a82;
}
.admin-panel__pill-value {
  font-size: 14px;
  font-weight: 600;
  color: #ebe8e1;
  font-variant-numeric: tabular-nums;
}
.admin-panel__top-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
  margin-left: auto;
}
.admin-panel__updated {
  margin-right: 8px;
  font-size: 13px;
  color: #8d8a82;
  white-space: nowrap;
}
.admin-panel__iconbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #aeaba2;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__iconbtn:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
}
.admin-panel__iconbtn:active:not(:disabled) {
  transform: scale(0.94);
}
.admin-panel__iconbtn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.admin-panel__iconbtn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}
.admin-panel__iconbtn--active {
  color: var(--gold-light);
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.07);
}
.admin-panel__iconbtns {
  display: inline-flex;
  gap: 4px;
}
.admin-panel__identity {
  position: relative;
  flex: none;
}
.admin-panel__identity-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  height: 36px;
  padding: 0 12px;
  justify-content: center;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__identity-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--gold-dark);
}
.admin-panel__identity-btn:active {
  transform: scale(0.98);
}
.admin-panel__identity-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__role {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  color: #ebe8e1;
}
.admin-panel__role--owner {
  color: var(--gold-light);
}
.admin-panel__identity-sub {
  font-size: 12px;
  line-height: 1.2;
  color: #8d8a82;
}
.admin-panel__popover {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  position: absolute;
  top: 100%;
  right: 0;
  width: 300px;
  margin-top: 8px;
  padding: 16px;
  z-index: 20;
  animation: admin-panel-toast-in 0.16s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__popover * {
  box-sizing: border-box;
}
.admin-panel__popover-title {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  margin-bottom: 12px;
}
.admin-panel__perm-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  margin-bottom: 12px;
}
.admin-panel__perm {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.admin-panel__perm--on {
  color: #ebe8e1;
}
.admin-panel__perm--on .admin-panel__icon {
  color: #8fbf8a;
}
.admin-panel__rail {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  padding: 16px 12px 24px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  min-height: 0;
}
.admin-panel__rail::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__rail::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__rail-group {
  margin-bottom: 16px;
}
.admin-panel__rail-title {
  padding: 0 12px 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8d8a82;
}
.admin-panel__nav {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 38px;
  padding: 0 12px;
  margin-bottom: 2px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 1px solid transparent;
  border-left: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__nav:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
}
.admin-panel__nav:active {
  transform: scale(0.985);
}
.admin-panel__nav:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__nav--active {
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.1);
  border-left-color: var(--gold-main);
}
.admin-panel__nav-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.admin-panel__nav-badge {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  flex: none;
}
.admin-panel__nav-badge--warn {
  color: #14100a;
  background: var(--gold-main);
}
.admin-panel__main {
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.admin-panel__viewwrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  animation: admin-panel-view-in 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.admin-panel__view {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 24px 24px 16px;
}
.admin-panel__view--scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: block;
}
.admin-panel__view--scroll::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__view--scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__view-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  flex: none;
}
.admin-panel__view-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.admin-panel__view-sub {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
}
.admin-panel__view-tools {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}
.admin-panel__toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-bottom: 12px;
  flex: none;
}
.admin-panel__toolbar--tight {
  margin-bottom: 12px;
}
.admin-panel__scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding-right: 4px;
}
.admin-panel__scroll::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__section {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 32px;
}
.admin-panel__input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: auto;
  color-scheme: dark;
}
.admin-panel__input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.admin-panel__input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.admin-panel__input--grow {
  flex: 1 1 220px;
  min-width: 160px;
}
.admin-panel__input--block {
  display: block;
  width: 100%;
}
.admin-panel__input--xs {
  width: 72px;
  padding: 5px 8px;
  text-align: center;
}
.admin-panel__input[aria-invalid=true] {
  border-color: #d9786d;
}
.admin-panel__input[readonly] {
  color: #aeaba2;
}
.admin-panel__searchfield {
  position: relative;
}
.admin-panel__searchfield-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  margin-top: -7px;
  color: #8d8a82;
  pointer-events: none;
}
.admin-panel__searchfield .admin-panel__input {
  padding-left: 34px;
}
.admin-panel__textarea {
  width: 100%;
  min-height: 96px;
  resize: vertical;
  line-height: 1.45;
}
.admin-panel__textarea--short {
  min-height: 64px;
}
.admin-panel__select-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.admin-panel__select-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.admin-panel__select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: auto;
  padding: 8px 12px;
  cursor: pointer;
  color-scheme: dark;
}
.admin-panel__select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.admin-panel__select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.admin-panel__select--block {
  flex: 1;
  width: 100%;
}
.admin-panel__select--sm {
  padding: 5px 8px;
  font-size: 13px;
}
.admin-panel__field-label {
  display: block;
  margin: 16px 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.admin-panel__field-label--first {
  margin-top: 0;
}
.admin-panel__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  font-size: 14px;
  color: #aeaba2;
  cursor: pointer;
  user-select: none;
}
.admin-panel__check input {
  width: 16px;
  height: 16px;
  accent-color: var(--gold-main);
  cursor: pointer;
}
.admin-panel__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  padding: 7px 12px;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.admin-panel__button:active:not(:disabled) {
  transform: translateY(1px);
}
.admin-panel__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.admin-panel__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__button--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.admin-panel__button--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.admin-panel__button--secondary {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.admin-panel__button--secondary:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.admin-panel__button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.admin-panel__button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.admin-panel__button--sm {
  padding: 5px 8px;
}
.admin-panel__button--on {
  border-color: var(--gold-main);
  color: var(--gold-light);
}
.admin-panel__button--danger-solid {
  color: #14100a;
  background: #d9786d;
  border-color: #d9786d;
}
.admin-panel__button--danger-solid:hover:not(:disabled) {
  background: #e48c82;
  border-color: #e48c82;
}
.admin-panel__empty-action {
  margin-top: 16px;
}
.admin-panel__linkbtn {
  margin-left: 8px;
  padding: 2px 4px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--gold-light);
  background: transparent;
  border: 0;
  border-radius: 3px;
  cursor: pointer;
}
.admin-panel__linkbtn:hover {
  text-decoration: underline;
}
.admin-panel__linkbtn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}
.admin-panel__linkbtn--flush {
  margin-left: 0;
}
.admin-panel__btnrow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.admin-panel__switch {
  position: relative;
  flex: none;
  width: 42px;
  height: 24px;
  padding: 0;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  cursor: pointer;
}
.admin-panel__switch:hover:not(:disabled) {
  border-color: var(--gold-dark);
}
.admin-panel__switch:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__switch:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.admin-panel__switch--on {
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.admin-panel__switch-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ebe8e1;
  transition: transform 0.16s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__switch--on .admin-panel__switch-knob {
  transform: translateX(18px);
  background: #14100a;
}
.admin-panel__segmented {
  display: inline-flex;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  overflow: hidden;
}
.admin-panel__seg {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}
.admin-panel__seg:last-child {
  border-right: 0;
}
.admin-panel__seg:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
}
.admin-panel__seg:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__seg--active {
  color: #14100a;
  background: var(--gold-main);
}
.admin-panel__seg--active:hover {
  color: #14100a;
  background: var(--gold-light);
}
.admin-panel__seg-count {
  font-size: 12px;
  font-weight: 600;
  opacity: 0.8;
}
.admin-panel__empty-state {
  padding: 32px 16px;
  text-align: center;
}
.admin-panel__empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #aeaba2;
}
.admin-panel__empty-text {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  max-width: 460px;
  margin: 8px auto 0;
}
.admin-panel__skeleton {
  padding: 8px 0;
}
.admin-panel__skeleton--stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}
.admin-panel__skeleton--cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}
.admin-panel__skel {
  display: block;
  height: 12px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  animation: admin-panel-pulse 0.9s ease-in-out infinite alternate;
}
.admin-panel__skel--label {
  width: 40%;
  height: 10px;
}
.admin-panel__skel--value {
  width: 30%;
  height: 26px;
  margin: 8px 0;
}
.admin-panel__skel--line {
  height: 12px;
  margin-bottom: 8px;
}
.admin-panel__skel--dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
}
.admin-panel__skel--grow {
  flex: 1;
}
.admin-panel__skel--field {
  height: 34px;
  margin-bottom: 12px;
}
.admin-panel__skel-stat, .admin-panel__skel-card {
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__skel-row {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 0 8px;
}
.admin-panel__skel-row .admin-panel__skel {
  margin: 0;
}
.admin-panel__tag {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  white-space: nowrap;
}
.admin-panel__tag:first-child {
  margin-left: 0;
}
.admin-panel__tag--danger {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.14);
}
.admin-panel__tag--warn {
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid var(--gold-dark);
}
.admin-panel__spill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
  border-radius: 10px;
  color: #8fbf8a;
  background: rgba(143, 191, 138, 0.16);
}
.admin-panel__spill--suspended {
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
}
.admin-panel__spill--expired {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.16);
}
.admin-panel__spill-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.admin-panel__spill-extra {
  font-weight: 400;
  opacity: 0.85;
}
.admin-panel__rolechip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #ebe8e1;
  white-space: nowrap;
}
.admin-panel__rolechip--none {
  color: #8d8a82;
  font-weight: 400;
}
.admin-panel__swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  flex: none;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.admin-panel__swatch--lg {
  width: 16px;
  height: 16px;
}
.admin-panel__banner {
  margin-bottom: 12px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 3px solid var(--gold-main);
  border-radius: 6px;
  flex: none;
}
.admin-panel__hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 8px 0 0;
}
.admin-panel__hint--warn {
  color: var(--gold-light);
}
.admin-panel__hint--inline {
  margin: 0;
  flex: 1;
}
.admin-panel__foot-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-top: 8px;
  flex: none;
}
.admin-panel__counter {
  margin-top: 4px;
  text-align: right;
  font-size: 12px;
  color: #8d8a82;
}
.admin-panel__sep {
  height: 1px;
  margin: 24px 0 16px;
  background: rgba(255, 255, 255, 0.12);
}
.admin-panel__toasts {
  position: absolute;
  right: 24px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
  z-index: 70;
}
.admin-panel__toast {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 12px 12px 16px;
  font-size: 14px;
  line-height: 1.4;
  border-left: 3px solid #8d8a82;
  backdrop-filter: none;
  animation: admin-panel-toast-in 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__toast * {
  box-sizing: border-box;
}
.admin-panel__toast--ok {
  border-left-color: #8fbf8a;
}
.admin-panel__toast--err {
  border-left-color: #d9786d;
}
.admin-panel__toast--info {
  border-left-color: var(--gold-main);
}
.admin-panel__toast-close {
  flex: none;
  display: inline-flex;
  padding: 2px;
  color: #8d8a82;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
.admin-panel__toast-close:hover {
  color: #ebe8e1;
}
.admin-panel__toast-close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}
.admin-panel__modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  z-index: 60;
}
.admin-panel__modal {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  width: 480px;
  max-width: 92%;
  padding: 24px;
  backdrop-filter: none;
  animation: admin-panel-view-in 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__modal * {
  box-sizing: border-box;
}
.admin-panel__modal-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 12px;
}
.admin-panel__modal-body {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin-bottom: 24px;
  word-wrap: break-word;
}
.admin-panel__modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.admin-panel__quote {
  display: block;
  margin-top: 8px;
  padding: 8px 12px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  white-space: pre-wrap;
}
.admin-panel__table {
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  min-height: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  overflow: hidden;
}
.admin-panel__table-body {
  flex: 0 1 auto;
  min-height: 0;
}
.admin-panel__table--narrow {
  width: 100%;
  max-width: 860px;
}
.admin-panel__vlist {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  position: relative;
}
.admin-panel__vlist::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__vlist::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__vlist:focus {
  outline: none;
}
.admin-panel__vlist:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__vrow {
  position: absolute;
  left: 0;
  right: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}
.admin-panel__vrow:hover {
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__vrow[aria-selected=true] {
  background: rgba(255, 255, 255, 0.06);
}
.admin-panel__prow {
  display: grid;
  grid-template-columns: 8px minmax(0, 1.6fr) 64px minmax(0, 1.4fr) 72px;
  align-items: center;
  gap: 12px;
  height: 100%;
  padding: 0 16px;
  border-left: 2px solid transparent;
}
.admin-panel__prow--head {
  height: 32px;
  font-size: 13px;
  font-weight: 600;
  color: #8d8a82;
  background: rgba(255, 255, 255, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex: none;
}
.admin-panel__prow--selected {
  border-left-color: var(--gold-main);
  background: rgba(255, 255, 255, 0.07);
}
.admin-panel__prow--offline .admin-panel__cell {
  color: #8d8a82;
}
.admin-panel__num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.admin-panel__lrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 100%;
  padding: 0 16px;
}
.admin-panel__stack {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.admin-panel__dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  flex: none;
  border-radius: 50%;
  background: #8d8a82;
}
.admin-panel__dot--online {
  background: #8fbf8a;
}
.admin-panel__cell {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.admin-panel__cell--name {
  font-weight: 600;
}
.admin-panel__cell--muted {
  color: #aeaba2;
  font-size: 13px;
}
.admin-panel__cell--muted {
  color: #aeaba2;
  font-size: 13px;
}
.admin-panel__players {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding: 0;
}
.admin-panel__players--drawer {
  grid-template-columns: minmax(0, 1fr) 400px;
}
.admin-panel__players-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 24px 24px 16px;
}
.admin-panel__drawer {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.025);
  animation: admin-panel-slide-in 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.admin-panel__drawer-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 24px 24px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex: none;
}
.admin-panel__drawer-id {
  min-width: 0;
}
.admin-panel__drawer-name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  display: flex;
  align-items: center;
  gap: 12px;
  word-break: break-word;
}
.admin-panel__drawer-state {
  margin-top: 8px;
  font-size: 13px;
  color: #aeaba2;
}
.admin-panel__drawer-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding: 4px 24px 24px;
}
.admin-panel__drawer-scroll::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__drawer-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__group {
  padding: 16px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__group:last-child {
  border-bottom: 0;
}
.admin-panel__group-title {
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8d8a82;
}
.admin-panel__dl {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 8px 12px;
  font-size: 14px;
}
.admin-panel__dl dt {
  color: #8d8a82;
}
.admin-panel__dl dd {
  color: #ebe8e1;
  word-break: break-word;
}
.admin-panel__dl--wide {
  grid-template-columns: 140px minmax(0, 1fr);
}
.admin-panel__wrap {
  word-break: break-all;
  font-size: 12px;
}
.admin-panel__gold {
  margin: 12px 0;
}
.admin-panel__gold-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.admin-panel__gold-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.admin-panel__gold-row .admin-panel__input {
  flex: 1;
  min-width: 0;
}
.admin-panel__card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  padding: 16px;
}
.admin-panel__card--flat {
  margin-bottom: 16px;
}
.admin-panel__card--narrow {
  max-width: 720px;
}
.admin-panel__card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.admin-panel__card-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}
.admin-panel__cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
  margin-bottom: 8px;
}
.admin-panel__status-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.admin-panel__weather-now {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.admin-panel__weather-group {
  margin-top: 16px;
}
.admin-panel__stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}
.admin-panel__stat {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 16px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-align: left;
  color: #ebe8e1;
}
.admin-panel__stat--link {
  cursor: pointer;
  transition: transform 0.14s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__stat--link:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  border-color: var(--gold-dark);
}
.admin-panel__stat--link:active:not(:disabled) {
  transform: scale(0.99);
}
.admin-panel__stat--link:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__stat--link:disabled {
  cursor: default;
}
.admin-panel__stat--alert {
  border-color: var(--gold-main);
}
.admin-panel__stat-value {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  color: var(--gold-light);
  font-variant-numeric: tabular-nums;
}
.admin-panel__stat-value--text {
  font-size: 22px;
  padding: 4px 0;
  word-break: break-word;
}
.admin-panel__stat-note {
  font-size: 13px;
  color: #8d8a82;
}
.admin-panel__mode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
}
.admin-panel__mode {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  justify-content: space-between;
  padding: 16px;
  font-size: 15px;
  text-align: left;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__mode:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.admin-panel__mode:active:not(:disabled) {
  transform: translateY(1px);
}
.admin-panel__mode:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.admin-panel__mode:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__mode--active {
  border-color: var(--gold-main);
}
.admin-panel__mode--active .admin-panel__mode-state {
  color: var(--gold-light);
}
.admin-panel__mode-state {
  font-size: 13px;
  font-weight: 600;
  color: #8d8a82;
}
.admin-panel__mini-list {
  margin-bottom: 8px;
}
.admin-panel__mini-row {
  display: grid;
  grid-template-columns: 8px minmax(0, 1.3fr) minmax(0, 1fr) 64px;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  text-align: left;
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}
.admin-panel__mini-row:hover {
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__mini-row:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__activity-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 14px;
}
.admin-panel__activity-row--err .admin-panel__activity-text {
  color: #d9786d;
}
.admin-panel__report {
  list-style: none;
  display: block;
}
.admin-panel__report--done {
  opacity: 0.8;
}
.admin-panel__report-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}
.admin-panel__report-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__report-where {
  flex: 1;
  min-width: 160px;
}
.admin-panel__templates {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}
.admin-panel__template {
  width: 100%;
  padding: 8px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  cursor: pointer;
}
.admin-panel__template:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: var(--gold-dark);
}
.admin-panel__template:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__copyline {
  display: flex;
  align-items: center;
  gap: 8px;
}
.admin-panel__copyline span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.admin-panel__copybtn {
  display: inline-flex;
  flex: none;
  padding: 4px;
  color: #aeaba2;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  cursor: pointer;
}
.admin-panel__copybtn:hover {
  color: #ebe8e1;
  border-color: var(--gold-dark);
}
.admin-panel__copybtn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__report-text {
  margin: 8px 0 12px;
  font-size: 15px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
.admin-panel__form {
  max-width: 720px;
}
.admin-panel__form-foot {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}
.admin-panel__form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.admin-panel__staff {
  overflow: hidden;
}
.admin-panel__subtabs {
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex: none;
}
.admin-panel__subtab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  padding: 8px 12px;
}
.admin-panel__subtab:hover {
  color: #ebe8e1;
}
.admin-panel__subtab:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__subtab--active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}
.admin-panel__subpanel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.admin-panel__staffgrid {
  display: flex;
  gap: 24px;
  flex: 1;
  min-height: 0;
}
.admin-panel__staffmain {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding-right: 8px;
}
.admin-panel__staffmain::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__staffmain::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__staffgrid--editor .admin-panel__cards--members {
  grid-template-columns: minmax(0, 1fr);
}
.admin-panel__cards--reports {
  grid-template-columns: minmax(0, 1fr);
  max-width: 900px;
}
.admin-panel__cards--members {
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
}
.admin-panel__cards--roles {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.admin-panel__staffgrid--editor .admin-panel__cards--roles {
  grid-template-columns: minmax(0, 1fr);
}
.admin-panel__mcard {
  position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.admin-panel__mcard:hover {
  border-color: var(--gold-dark);
}
.admin-panel__mcard--active {
  border-color: var(--gold-main);
  background: rgba(255, 255, 255, 0.08);
}
.admin-panel__mcard--dim .admin-panel__mcard-body {
  opacity: 0.7;
}
.admin-panel__mcard-check {
  flex: none;
  width: 16px;
  height: 16px;
  margin: 16px 0 0 12px;
  accent-color: var(--gold-main);
  cursor: pointer;
}
.admin-panel__mcard-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 12px 16px 12px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-align: left;
  color: #ebe8e1;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
.admin-panel__mcard-body:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__mcard-top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.admin-panel__mcard-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
}
.admin-panel__mcard-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}
.admin-panel__mcard-meta {
  font-size: 13px;
  line-height: 1.4;
  color: #8d8a82;
  word-break: break-word;
}
.admin-panel__rcard {
  display: flex;
  width: 100%;
  padding: 0;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-align: left;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}
.admin-panel__rcard:hover {
  border-color: var(--gold-dark);
}
.admin-panel__rcard:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__rcard--active {
  border-color: var(--gold-main);
  background: rgba(255, 255, 255, 0.08);
}
.admin-panel__rcard-bar {
  flex: none;
  width: 6px;
}
.admin-panel__rcard-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  min-width: 0;
}
.admin-panel__rcard-top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.admin-panel__rcard-name {
  font-size: 16px;
  font-weight: 600;
}
.admin-panel__rcard-desc {
  font-size: 13px;
  line-height: 1.4;
  color: #aeaba2;
}
.admin-panel__rcard-meta {
  font-size: 13px;
  color: #8d8a82;
}
.admin-panel__bulkbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--gold-dark);
  border-radius: 6px;
  animation: admin-panel-view-in 0.16s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__bulkcount {
  font-size: 14px;
  font-weight: 600;
  color: var(--gold-light);
}
.admin-panel__bulkgroup {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.admin-panel__tablewrap {
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.admin-panel__dtable {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.admin-panel__dtable th {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  color: #8d8a82;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__dtable td {
  padding: 8px 12px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__dtable tbody tr {
  cursor: pointer;
}
.admin-panel__dtable tbody tr:hover {
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__dtable tbody tr.is-active {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 2px 0 0 var(--gold-main);
}
.admin-panel__dtable tbody tr.is-dim td {
  opacity: 0.7;
}
.admin-panel__dtable .admin-panel__num {
  text-align: right;
}
.admin-panel__staffgrid--editor .admin-panel__col-hide {
  display: none;
}
.admin-panel__col-check {
  width: 36px;
}
.admin-panel__rowlink {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #ebe8e1;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.admin-panel__rowlink:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__owners {
  margin-top: 8px;
}
.admin-panel__owner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__editor {
  display: flex;
  flex-direction: column;
  flex: none;
  width: 520px;
  min-height: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.03);
  animation: admin-panel-slide-in 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.admin-panel__editor-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex: none;
}
.admin-panel__editor-id {
  min-width: 0;
}
.admin-panel__editor-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  word-break: break-word;
}
.admin-panel__editor-sub {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-top: 8px;
}
.admin-panel__editor-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding: 0 24px 16px;
}
.admin-panel__editor-scroll::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__editor-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__editor-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  flex: none;
}
.admin-panel__editor-save {
  display: flex;
  align-items: center;
  gap: 12px;
}
.admin-panel__dirty {
  font-size: 13px;
  color: var(--gold-light);
}
.admin-panel__esec {
  padding: 16px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__esec:last-child {
  border-bottom: 0;
}
.admin-panel__esec-title {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8d8a82;
}
.admin-panel__switchrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 8px;
}
.admin-panel__expiry {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.admin-panel__expiry .admin-panel__chip {
  margin: 0;
}
.admin-panel__rolepick {
  display: flex;
  align-items: center;
  gap: 12px;
}
.admin-panel__candidates {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
  max-height: 300px;
  overflow-y: auto;
}
.admin-panel__candidate {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  text-align: left;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  cursor: pointer;
}
.admin-panel__candidate:hover {
  background: rgba(255, 255, 255, 0.09);
  border-color: var(--gold-dark);
}
.admin-panel__candidate:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__matrix {
  margin: 12px 0 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.admin-panel__matrix-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__matrix-row:last-child {
  border-bottom: 0;
}
.admin-panel__matrix-row--on {
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__matrix-text {
  flex: 1;
  min-width: 0;
}
.admin-panel__matrix-label {
  font-size: 14px;
  font-weight: 600;
}
.admin-panel__matrix-desc {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.4;
  color: #8d8a82;
}
.admin-panel__tri {
  display: inline-flex;
  flex: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  overflow: hidden;
}
.admin-panel__tri-opt {
  padding: 5px 8px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}
.admin-panel__tri-opt:last-child {
  border-right: 0;
}
.admin-panel__tri-opt:hover:not(:disabled):not(.admin-panel__tri-opt--on) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
}
.admin-panel__tri-opt:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.admin-panel__tri-opt:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.admin-panel__tri-opt--on {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.1);
}
.admin-panel__tri-opt--add.admin-panel__tri-opt--on {
  color: #8fbf8a;
  background: rgba(143, 191, 138, 0.16);
}
.admin-panel__tri-opt--deny.admin-panel__tri-opt--on {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.16);
}
.admin-panel__final {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 24px;
  height: 24px;
  color: #8d8a82;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.admin-panel__final--on {
  color: #8fbf8a;
  border-color: #8fbf8a;
  background: rgba(143, 191, 138, 0.16);
}
.admin-panel__previewline {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 12px;
}
.admin-panel__previewlabel {
  flex: none;
  width: 56px;
  padding-top: 2px;
  font-size: 13px;
  color: #8d8a82;
}
.admin-panel__chipline {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 4px;
}
.admin-panel__chipline .admin-panel__tag {
  margin-left: 0;
}
.admin-panel__palette {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.admin-panel__colorbtn {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__colorbtn:hover {
  transform: scale(1.08);
}
.admin-panel__colorbtn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__colorbtn--on {
  border-color: #ebe8e1;
}
.admin-panel__timeline {
  position: relative;
  margin-top: 12px;
}
.admin-panel__tl-item {
  position: relative;
  display: flex;
  gap: 12px;
  padding: 0 0 16px 24px;
}
.admin-panel__tl-item::before {
  content: "";
  position: absolute;
  top: 12px;
  bottom: -4px;
  left: 4px;
  width: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.admin-panel__tl-item:last-child::before {
  display: none;
}
.admin-panel__tl-dot {
  position: absolute;
  top: 5px;
  left: 0;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #8d8a82;
}
.admin-panel__tl-dot--member {
  background: var(--gold-main);
}
.admin-panel__tl-dot--role {
  background: #8fbf8a;
}
.admin-panel__tl-dot--bulk {
  background: #d9786d;
}
.admin-panel__tl-main {
  min-width: 0;
}
.admin-panel__tl-title {
  font-size: 14px;
  font-weight: 600;
}
.admin-panel__tl-target {
  margin-left: 8px;
  font-weight: 400;
  color: var(--gold-light);
}
.admin-panel__tl-detail {
  margin-top: 2px;
  font-size: 14px;
  line-height: 1.45;
  color: #aeaba2;
}
.admin-panel__tl-meta {
  margin-top: 2px;
  font-size: 12px;
  color: #8d8a82;
}
.admin-panel__timeline--small {
  margin-top: 8px;
}
.admin-panel__timeline--small .admin-panel__tl-item {
  padding-bottom: 12px;
}
.admin-panel__matrixtab, .admin-panel__audittab, .admin-panel__toolstab {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding-right: 8px;
}
.admin-panel__matrixtab::-webkit-scrollbar, .admin-panel__audittab::-webkit-scrollbar, .admin-panel__toolstab::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__matrixtab::-webkit-scrollbar-thumb, .admin-panel__audittab::-webkit-scrollbar-thumb, .admin-panel__toolstab::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: #aeaba2;
}
.admin-panel__legend li {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.admin-panel__tablewrap--matrix {
  margin-top: 12px;
}
.admin-panel__mtable {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: 13px;
}
.admin-panel__mtable th, .admin-panel__mtable td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  white-space: nowrap;
}
.admin-panel__mtable thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  font-weight: 600;
  color: #aeaba2;
  background: rgb(20, 24, 29);
}
.admin-panel__mtable tr.is-dim td, .admin-panel__mtable tr.is-dim th {
  opacity: 0.55;
}
.admin-panel__mtable tbody tr:hover td, .admin-panel__mtable tbody tr:hover th {
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__mtable tfoot th, .admin-panel__mtable tfoot td {
  font-weight: 600;
  background: rgb(20, 24, 29);
  border-bottom: 0;
}
.admin-panel__mtable-first {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 220px;
  text-align: left !important;
  background: rgb(15, 19, 24);
}
.admin-panel__mtable thead .admin-panel__mtable-first {
  z-index: 3;
  background: rgb(20, 24, 29);
}
.admin-panel__mname {
  display: block;
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: 600;
  color: #ebe8e1;
}
.admin-panel__mtable-total {
  font-variant-numeric: tabular-nums;
  color: var(--gold-light);
}
.admin-panel__mx {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #8d8a82;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.1s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__mx:hover {
  border-color: var(--gold-main);
}
.admin-panel__mx:active {
  transform: scale(0.9);
}
.admin-panel__mx:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__mx--inherit-on {
  color: var(--gold-light);
  border-color: var(--gold-dark);
}
.admin-panel__mx--add {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.admin-panel__mx--deny {
  color: #d9786d;
  border-color: #d9786d;
  background: rgba(217, 120, 109, 0.16);
}
.admin-panel__tool {
  max-width: 860px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__tool:last-child {
  border-bottom: 0;
}
.admin-panel__tool-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 4px;
}
.admin-panel__code {
  min-height: 140px;
  margin: 12px 0;
  font-family: Consolas, "Courier New", monospace;
  font-size: 12px;
  line-height: 1.5;
  resize: vertical;
  white-space: pre;
}
.admin-panel__importsum {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
}
.admin-panel__importlist {
  max-height: 240px;
  margin-bottom: 12px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.admin-panel__importline {
  display: flex;
  gap: 12px;
  padding: 8px 12px;
  font-size: 13px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__importline:last-child {
  border-bottom: 0;
}
.admin-panel__importline--error {
  color: #d9786d;
}
.admin-panel__importline--same {
  color: #8d8a82;
}
.admin-panel__importkind {
  flex: none;
  width: 88px;
  font-weight: 600;
}
.admin-panel__body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}
.admin-panel__filters {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.admin-panel__online-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
  white-space: nowrap;
  color: #aeaba2;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}
.admin-panel__online-toggle input {
  width: 16px;
  height: 16px;
  accent-color: var(--gold-main);
  cursor: pointer;
}
.admin-panel__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.admin-panel__row--head {
  padding-top: 4px;
  padding-bottom: 8px;
  color: #8d8a82;
  font-size: 13px;
  font-weight: 600;
}
.admin-panel__row--location {
  justify-content: space-between;
}
.admin-panel__row--offline {
  color: #8d8a82;
}
.admin-panel__cell--discord-id {
  color: #aeaba2;
}
.admin-panel__list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
}
.admin-panel__list::-webkit-scrollbar {
  width: 6px;
}
.admin-panel__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.admin-panel__empty {
  padding: 24px 0;
  color: #8d8a82;
  font-size: 14px;
}
.admin-panel__time {
  margin-bottom: 16px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
}
.admin-panel__time-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.admin-panel__time-clock {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 1px;
  font-variant-numeric: tabular-nums;
}
.admin-panel__time-note {
  color: #8d8a82;
  font-size: 13px;
}
.admin-panel__time-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.admin-panel__time-sep {
  flex: 1;
}
.admin-panel__time-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: 64px;
  text-align: center;
}
.admin-panel__time-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.admin-panel__time-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.admin-panel__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.admin-panel__chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  padding: 5px 12px;
  transition: transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
}
.admin-panel__chip:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.admin-panel__chip:active:not(:disabled) {
  transform: translateY(1px);
}
.admin-panel__chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.admin-panel__chip:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.admin-panel__chip--active, .admin-panel__chip[aria-pressed=true] {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.admin-panel__chip--active:hover:not(:disabled), .admin-panel__chip[aria-pressed=true]:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.admin-panel__search {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  flex: 1;
  width: auto;
}
.admin-panel__search:focus {
  outline: none;
  border-color: var(--gold-main);
}
.admin-panel__search::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.admin-panel__badge {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  margin-right: 2px;
}

@media (max-width: 1500px) {
  .admin-panel__updated {
    display: none;
  }
}
@media (max-width: 1280px) {
  .admin-panel__pill--uptime {
    display: none;
  }
  .admin-panel__brand {
    width: auto;
  }
  .admin-panel__window {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .admin-panel__nav {
    gap: 8px;
  }
  .admin-panel__players--drawer {
    grid-template-columns: minmax(0, 1fr) 360px;
  }
  .admin-panel__editor {
    width: 440px;
  }
}
@media (max-width: 900px), (max-height: 560px) {
  .admin-panel__window {
    width: 100%;
    height: 100%;
    border-radius: 0;
    border: 0;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto auto minmax(0, 1fr);
  }
  .admin-panel__top {
    flex-wrap: wrap;
    gap: 8px 12px;
    padding: 12px;
  }
  .admin-panel__brand {
    order: 1;
    padding-left: 0;
  }
  .admin-panel__top-actions {
    order: 2;
    margin-left: auto;
  }
  .admin-panel__gsearch {
    order: 3;
    flex: 1 1 100%;
    max-width: none;
  }
  .admin-panel__pills {
    order: 4;
    flex-wrap: wrap;
  }
  .admin-panel__pill:first-child {
    padding-left: 0;
  }
  .admin-panel__rail {
    display: flex;
    gap: 16px;
    padding: 8px 12px;
    overflow-x: auto;
    overflow-y: hidden;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  .admin-panel__rail-group {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0;
    flex: none;
  }
  .admin-panel__rail-title {
    display: none;
  }
  .admin-panel__nav {
    width: auto;
    height: 34px;
    margin: 0;
    white-space: nowrap;
    border-left-width: 1px;
  }
  .admin-panel__nav--active {
    border-bottom: 2px solid var(--gold-main);
  }
  .admin-panel__view {
    padding: 16px 12px 12px;
  }
  .admin-panel__players-main {
    padding: 16px 12px 12px;
  }
  .admin-panel__players--drawer {
    grid-template-columns: minmax(0, 1fr);
  }
  .admin-panel__drawer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    background: rgba(11, 15, 19, 0.99);
    border-left: 0;
  }
  .admin-panel__columns {
    grid-template-columns: minmax(0, 1fr);
  }
  .admin-panel__staffgrid {
    flex-direction: column;
    overflow-y: auto;
  }
  .admin-panel__staffmain {
    overflow: visible;
    flex: none;
    padding-right: 0;
  }
  .admin-panel__staffgrid--editor .admin-panel__staffmain {
    display: none;
  }
  .admin-panel__editor {
    width: 100%;
    flex: 1;
  }
  .admin-panel__cards, .admin-panel__cards--members, .admin-panel__cards--roles {
    grid-template-columns: minmax(0, 1fr);
  }
  .admin-panel__toasts {
    right: 12px;
    bottom: 12px;
    left: 12px;
    max-width: none;
  }
  .admin-panel__subtabs {
    overflow-x: auto;
  }
}
.admin-panel--compact .admin-panel__nav {
  height: 32px;
  font-size: 14px;
}
.admin-panel--compact .admin-panel__rail-group {
  margin-bottom: 12px;
}
.admin-panel--compact .admin-panel__view {
  padding-top: 16px;
}
.admin-panel--compact .admin-panel__view-head {
  margin-bottom: 12px;
}
.admin-panel--compact .admin-panel__players-main {
  padding-top: 16px;
}
.admin-panel--compact .admin-panel__group {
  padding: 12px 0;
}
.admin-panel--compact .admin-panel__mcard-body {
  gap: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.admin-panel--compact .admin-panel__dtable td {
  padding-top: 4px;
  padding-bottom: 4px;
}
.admin-panel--compact .admin-panel__matrix-row {
  padding-top: 8px;
  padding-bottom: 8px;
}
.admin-panel--compact .admin-panel__stat {
  padding: 12px;
}
.admin-panel--compact .admin-panel__esec {
  padding: 12px 0;
}

@media (prefers-reduced-motion: reduce) {
  .admin-panel,
  .admin-panel * {
    animation: none !important;
    transition: none !important;
  }
  .admin-panel__window {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/adminPanel/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAwBA;EACE;IAAO,UAAA;IAAY,0BAAA;EApBnB;EAqBA;IAAK,UAAA;IAAY,eAAA;EAjBjB;AACF;AAmBA;EACE;IAAO,UAAA;IAAY,2BAAA;EAfnB;EAgBA;IAAK,UAAA;IAAY,eAAA;EAZjB;AACF;AAcA;EACE;IAAO,UAAA;IAAY,0BAAA;EAVnB;EAWA;IAAK,UAAA;IAAY,eAAA;EAPjB;AACF;AASA;EACE;IAAO,aAAA;EANP;EAOA;IAAK,aAAA;EAJL;AACF;AAMA;EACE;IAAO,4BAAA;EAHP;EAIA;IAAK,2BAAA;EADL;AACF;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDDrCU;ECsCV,cD/CK;ECgDL,WAAA;EACA,8BAAA;EACA,UAAA;EACA,uDAAA;AADF;AAGE;EAAU,UAAA;AAAZ;AAEE;EAAI,sBAAA;AACN;AACE;EAA4B,SAAA;EAAW,UAAA;AAGzC;AAFE;EAAK,gBAAA;AAKP;AAHE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAKJ;AAFE;EAAU,UAAA;EAAY,cAAA;AAMxB;AAJE;ED3DA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECkDE,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,2CAAA;EACA,uCAAA;EACA,gBAAA;EACA,wCAAA;EACA,wDAAA;AAWJ;ADlFE;EAAI,sBAAA;ACqFN;AAXE;EAAoB,eAAA;AActB;AAVE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,uDAAA;EACA,oBAAA;AAYJ;AAVI;EAAQ,UAAA;AAaZ;AAVE;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;EACA,oDAAA;AAYJ;AAPE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SA3HC;EA4HD,4BAAA;EACA,kDAAA;EACA,qCDhIS;ACyIb;AANE;EAAW,UAAA;EAAY,YAAA;EAA4B,iBAnIhD;AA8IL;AAVE;ED7FA,kDA3BW;EA4BX,gBAAA;EACA,eC2F8B;ED1F9B,iBAAA;EACA,sBAAA;EACA,cAxCK;ECgIgC,mBAAA;AAmBvC;AAjBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAmBJ;AAhBE;EAAkB,kBAAA;EAAoB,QAAA;EAAU,UA5I7C;EA4IwD,gBAAA;EAAkB,cDvItE;ECuI0F,oBAAA;AAwBnG;AAvBE;EAA6B,WAAA;EAAa,kBAAA;EAAoB,mBAAA;AA4BhE;AA1BE;EACE,kBAAA;EACA,QAAA;EACA,UAnJC;EAoJD,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yDD1IQ;EC2IR,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cDrJK;ECsJL,0CAAA;EACA,kBDpJK;ECqJL,oBAAA;AA4BJ;AAzBE;EDjJA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECuIE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAvKC;EAwKD,YAzKC;EA0KD,WAAA;EACA,iBAAA;EACA,gBAAA;AAiCJ;AD1LE;EAAI,sBAAA;AC6LN;AAjCE;EAAkB,aA7Kf;EA6K6B,cDxKzB;ECwK6C,eAAA;AAsCtD;AApCE;EACE,aAAA;EACA,mBAAA;EACA,SAlLC;EAmLD,iBAAA;EACA,kBD5KK;EC6KL,eAAA;AAsCJ;AApCI;EAAY,oCA1KF;AAiNd;AApCE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAsCJ;AAnCE;EACE,oBAAA;EACA,qBAAA;EACA,QApMC;EAqMD,eAAA;EACA,mBAAA;EACA,gDAAA;AAqCJ;AAnCI;EAAgB,cAAA;AAsCpB;AArCI;EAAoC,cDnM/B;AC2OT;AArCE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cDvM5C;ACiPT;AAzCE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cD1M9C;EC0MgE,kCAAA;AA+CvE;AA7CE;EAAiB,aAAA;EAAe,mBAAA;EAAqB,QAhNlD;EAgN4D,UAAA;EAAY,iBAAA;AAoD7E;AAnDE;EAAa,iBAjNV;EAiN6B,eAAA;EAAiB,cD3M1C;EC2M8D,mBAAA;AAyDvE;AAvDE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cDrNK;ECsNL,uBAAA;EACA,6BAAA;EACA,kBDpNK;ECqNL,eAAA;EACA,yDAAA;AAyDJ;AAvDI;EAAyB,cD7NtB;EC6NwC,qCApNlC;AA+Qb;AA1DI;EAA0B,sBAAA;AA6D9B;AA5DI;EAAa,YAAA;EAAc,mBAAA;AAgE/B;AA/DI;EAAkB,oCAAA;EAAsC,mBAAA;AAmE5D;AAlEI;EAAY,wBAAA;EAA0B,sCDlO5B;ECkO4D,qCAxN7D;AA+Rb;AApEE;EAAc,oBAAA;EAAsB,QAzOjC;AAiTL;AAtEE;EAAc,kBAAA;EAAoB,UAAA;AA0EpC;AAxEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,yDDvOQ;ECwOR,cDjPG;ECkPH,qCAAA;EACA,0CAAA;EACA,kBD/OK;ECgPL,eAAA;EACA,yDAAA;AA0EJ;AAxEI;EAAU,oCA9OA;EA8O0B,8BAAA;AA4ExC;AA3EI;EAAW,sBAAA;AA8Ef;AA7EI;EAAkB,oCAAA;EAAsC,mBAAA;AAiF5D;AA9EE;EAAU,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,cD7P1D;ACiVP;AAnFE;EAAiB,wBAAA;AAsFnB;AArFE;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,cD7P9C;ACuVT;AAxFE;EDrPA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC2OE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,eA3QC;EA4QD,aA1QC;EA2QD,WAAA;EACA,mEAAA;AAgGJ;AD5VE;EAAI,sBAAA;AC+VN;AAhGE;EDrNA,eAAA;EACA,gBAAA;EACA,cAzDO;EC4QgC,mBAhRpC;AAsXL;AArGE;EAAe,aAAA;EAAe,8BAAA;EAAgC,aAAA;EAAc,mBAjRzE;AA4XL;AAzGE;EACE,aAAA;EACA,mBAAA;EACA,QAvRC;EAwRD,eAAA;EACA,cDnRK;AC8XT;AAzGI;EAAQ,cDvRL;ACmYP;AA5G8B;EAAqB,cDnRzC;ACkYV;AA1GE;ED5IA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC4IE,uBAAA;EACA,iDAAA;EACA,aAAA;AA8GJ;AD1PE;EAAuB,UAAA;AC6PzB;AD5PE;EAA6B,oCAAA;EAAsC,kBAAA;ACgQrE;AAlHE;EAAgB,mBArSb;AA0ZL;AAnHE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cDzSK;AC8ZT;AAlHE;EACE,aAAA;EACA,mBAAA;EACA,SApTC;EAqTD,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yDD7SQ;EC8SR,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDzTK;EC0TL,uBAAA;EACA,6BAAA;EACA,kCAAA;EACA,kBDzTK;EC0TL,eAAA;EACA,yDAAA;AAoHJ;AAlHI;EAAU,cDlUP;ECkUyB,qCAzTnB;AA+ab;AArHI;EAAW,uBAAA;AAwHf;AAvHI;EAAkB,oCAAA;EAAsC,oBAAA;AA2H5D;AAzHI;EACE,wBAAA;EACA,oCA9TQ;EA+TR,mCAAA;AA2HN;AAvHE;EAAe,OAAA;EAAS,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA8HnF;AA5HE;ED3MA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;ECqME,UAAA;AAsIJ;AApII;EAAU,cD7UF;EC6UyB,4BAAA;AAwIrC;AAnIE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAqIJ;AAlIE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,uEAAA;AAoIJ;AAjIE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;AAmIJ;AAjII;EDhOF,gBAAA;EACA,qBAAA;EACA,qDAAA;ECgOI,cAAA;AAqIN;ADnWE;EAAuB,UAAA;ACsWzB;ADrWE;EAA6B,oCAAA;EAAsC,kBAAA;ACyWrE;AAxIE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SA5XC;EA6XD,mBA7XC;EA8XD,UAAA;AA0IJ;AAvIE;ED5VA,kDA3BW;EA4BX,gBAAA;EACA,eC0VmC;EDzVnC,iBAAA;EACA,sBAAA;EACA,cAxCK;AC8gBP;AA9IE;EAAc,eArYX;EAqY4B,eAAA;EAAiB,gBAAA;EAAkB,cD/X3D;ACmhBT;AAnJE;EAAgB,aAAA;EAAe,mBAAA;EAAqB,QArYjD;EAqY2D,UAAA;AAyJhE;AAvJE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBA3YC;EA4YD,UAAA;AAyJJ;AAvJI;EAAW,mBA9YV;AAwiBL;AAvJE;ED9PA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC8PE,OAAA;EACA,aAAA;EACA,kBAvZC;AAkjBL;ADzZE;EAAuB,UAAA;AC4ZzB;AD3ZE;EAA6B,oCAAA;EAAsC,kBAAA;AC+ZrE;AA/JE;EAAa,gBAtZV;EAsZ2B,iBAvZ3B;EAuZ6C,+CAAA;AAoKlD;AAnKE;EAAa,aAAA;EAAe,gDAAA;EAAkD,WAAA;AAwKhF;AApKE;EDtSA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECgSE,WAAA;EACA,kBAAA;AA8KJ;AD7cE;EAAU,aAAA;EAAe,8BAAA;ACid3B;ADhdE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACud1G;AAvLI;EAAU,eAAA;EAAiB,gBAAA;AA2L/B;AA1LI;EAAW,cAAA;EAAgB,WAAA;AA8L/B;AA7LI;EAAQ,WAAA;EAAa,gBAAA;EAAkB,kBAAA;AAkM3C;AAjMI;EAAyB,qBD/ZpB;ACmmBT;AAnMI;EAAc,cDlaT;ACwmBT;AAnME;EAAiB,kBAAA;AAsMnB;AArME;EAAsB,kBAAA;EAAoB,QAAA;EAAU,UA1ajD;EA0a4D,gBAAA;EAAkB,cDra1E;ECqa8F,oBAAA;AA6MvG;AA5ME;EAA0B,kBAAA;AA+M5B;AA7ME;EAAc,WAAA;EAAa,gBAAA;EAAkB,gBAAA;EAAkB,iBAAA;AAmNjE;AAnNoF;EAAW,gBAAA;AAsN/F;AApNE;EAAiB,oBAAA;EAAsB,mBAAA;EAAqB,QAhbzD;AAyoBL;AAxNE;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,cD5a9C;ACyoBT;AA3NE;ED3TA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECqTE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAqOJ;AD3hBE;EAAU,aAAA;EAAe,8BAAA;AC+hB3B;AD9hBE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACqiB1G;AA9OI;EAAW,OAAA;EAAS,WAAA;AAkPxB;AAjPI;EAAQ,gBAAA;EAAkB,eAAA;AAqP9B;AAlPE;EACE,cAAA;EACA,kBAAA;EDpYF,eAAA;EACA,gBAAA;EACA,cAzDO;ACkrBT;AApPI;EAAW,aAAA;AAuPf;AApPE;EACE,oBAAA;EACA,mBAAA;EACA,QAzcC;EA0cD,iBAAA;EACA,eAAA;EACA,cDvcK;ECwcL,eAAA;EACA,iBAAA;AAsPJ;AApPI;EAAQ,WAAA;EAAa,YAAA;EAAc,8BAAA;EAAgC,eAAA;AA0PvE;AArPE;EDlZA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;ECoWE,iBAAA;EACA,yDAAA;AAuQJ;AD5oBE;EAAyB,qCAAA;EAAuC,8BAAA;ACgpBlE;AD/oBE;EAA0B,0BAAA;ACkpB5B;ADjpBE;EAAa,YAAA;EAAc,mBAAA;ACqpB7B;ADppBE;EAAkB,oCAAA;EAAsC,mBAAA;ACwpB1D;AApRI;EDhYF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACupBF;ADrpBE;EAAyB,6BAAA;EAA+B,+BAAA;ACypB1D;AA5RI;EDjXF,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACgpBF;AD9oBE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACmpBhF;AArSI;ED1XF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACkqBF;ADhqBE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACowBT;AA7SI;EAAQ,gBAAA;AAgTZ;AA/SI;EAAQ,8BAAA;EAAgC,wBAAA;AAmT5C;AAjTI;EACE,cDxdM;ECydN,mBD5dG;EC6dH,qBD7dG;ACgxBT;AAjTM;EAAyB,mBAAA;EAAqB,qBAAA;AAqTpD;AAjTE;EAAkB,gBAxef;AA4xBL;AAlTE;EACE,gBA7eC;EA8eD,gBAAA;EACA,yDDleQ;ECmeR,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAoTJ;AAlTI;EAAU,0BAAA;AAqTd;AApTI;EAAkB,oCAAA;EAAsC,mBAAA;AAwT5D;AAvTI;EAAW,cAAA;AA0Tf;AAvTE;EAAY,aAAA;EAAe,eAAA;EAAiB,mBAAA;EAAqB,QA7f9D;AA0zBL;AA3TE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;AA6TJ;AA3TI;EAAyB,8BAAA;AA8T7B;AA7TI;EAAkB,oCAAA;EAAsC,mBAAA;AAiU5D;AAhUI;EAAa,YAAA;EAAc,mBAAA;AAoU/B;AAlUI;EAAQ,4BAAA;EAA8B,8BAAA;AAsU1C;AAnUE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBDphBG;ECqhBH,yDAAA;AAqUJ;AAnUE;EAA+B,2BAAA;EAA6B,mBDjhBlD;ACw1BZ;AArUE;EACE,oBAAA;EACA,0CAAA;EACA,kBDvhBK;ECwhBL,gBAAA;AAuUJ;AApUE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDD5hBQ;EC6hBR,eAAA;EACA,gBAAA;EACA,cDviBK;ECwiBL,uBAAA;EACA,SAAA;EACA,iDAAA;EACA,eAAA;AAsUJ;AApUI;EAAe,eAAA;AAuUnB;AAtUI;EAAU,cD/iBP;EC+iByB,qCAtiBnB;AAg3Bb;AAzUI;EAAkB,oCAAA;EAAsC,oBAAA;AA6U5D;AA3UI;EAAY,cD5iBJ;EC4iB2B,4BAAA;AA+UvC;AA/UqE;EAAU,cD5iBnE;EC4iB0F,6BAAA;AAmVtG;AAhVE;EAAe,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AAqVpD;AAjVE;EAAiB,kBAAA;EAAkB,kBAAA;AAqVrC;AApVE;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,cDzjB7C;ACk5BT;AAxVE;EDzgBA,eAAA;EACA,gBAAA;EACA,cAlDO;ECyjB4B,gBAAA;EAAkB,kBAAA;AA+VvD;AA7VE;EAAc,cAAA;AAgWhB;AA/VE;EAAqB,aAAA;EAAe,2DAAA;EAA6D,SAjkB9F;AAq6BL;AAnWE;EAAqB,aAAA;EAAe,4DAAA;EAA8D,SAlkB/F;AA06BL;AAtWE;EACE,cAAA;EACA,YAAA;EACA,qCAAA;EACA,kBDhkBK;ECikBL,gEAAA;AAwWJ;AAtWI;EAAW,UAAA;EAAY,YAAA;AA0W3B;AAzWI;EAAW,UAAA;EAAY,YAAA;EAAc,aAAA;AA8WzC;AA7WI;EAAU,YAAA;EAAc,kBA9kBvB;AA+7BL;AAhXI;EAAS,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,UAAA;AAsX1D;AArXI;EAAU,OAAA;AAwXd;AAvXI;EAAW,YAAA;EAAc,mBAhlBxB;AA28BL;AAxXE;EAA6B,aAllB1B;EAklBwC,2CAAA;EAA6B,kBD3kBjE;EC2kB6F,qCDplBzF;ACk9Bb;AA7XE;EAAc,aAAA;EAAe,mBAAA;EAAqB,SAplB/C;EAolByD,YAAA;EAAc,kDAAA;EAAoC,cAAA;AAqYhH;AApYE;EAAiC,SAAA;AAuYnC;AArYE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cD1lBK;EC2lBL,qCAAA;EACA,mBAAA;EACA,mBAAA;AAuYJ;AArYI;EAAgB,cAAA;AAwYpB;AAvYI;EAAY,cD9lBP;EC8lB2B,qCAAA;AA2YpC;AA1YI;EAAU,wBAAA;EAA0B,qCAAA;EAAuC,kCAAA;AA+Y/E;AA5YE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cD3mBM;EC4mBN,qCAzmBM;AAu/BV;AA5YI;EAAe,cDjnBV;ECinB8B,qCAAA;AAgZvC;AA/YI;EAAa,cDhnBR;ECgnB4B,qCA3mBvB;AA8/Bd;AAhZE;EAAe,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,wBAAA;AAsZ9D;AArZE;EAAiB,gBAAA;EAAkB,aAAA;AAyZrC;AAvZE;EAAc,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,gBAAA;EAAkB,cDznBjG;ECynBmH,mBAAA;AAga1H;AAha+I;EAAU,cDvnBhJ;ECunBoK,gBAAA;AAoa7K;AAnaE;EAAY,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,UAAA;EAAY,kBAAA;EAAoB,0CAAA;AA2ahG;AA3aoI;EAAQ,WAAA;EAAa,YAAA;AA+azJ;AA7aE;EACE,mBAhoBC;EAioBD,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDhoBK;ECioBL,qCDtoBS;ECuoBT,2CAAA;EACA,uCAAA;EACA,kBDhoBK;ECioBL,UAAA;AA+aJ;AA5aE;EDvlBA,eAAA;EACA,gBAAA;EACA,cAlDO;ECyoBL,eAAA;AAgbJ;AA9aI;EAAU,wBAAA;AAibd;AAhbI;EAAY,SAAA;EAAW,OAAA;AAob3B;AAjbE;ED/lBA,eAAA;EACA,gBAAA;EACA,cAlDO;EC+oB2B,eArpB/B;EAqpBgD,UAAA;AAwbrD;AAvbE;EAAa,eAvpBV;EAupB2B,iBAAA;EAAmB,eAAA;EAAiB,cDhpB3D;AC6kCT;AA5bE;EAAS,WAAA;EAAa,mBAAA;EAAmB,qCDrpBpC;ACslCP;AA7bE;EACE,kBAAA;EACA,WA1pBC;EA2pBD,YA3pBC;EA4pBD,aAAA;EACA,sBAAA;EACA,QAjqBC;EAkqBD,gBAAA;EACA,WAAA;AA+bJ;AA5bE;EDtpBA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC4oBE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SA1qBC;EA2qBD,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kEAAA;AAocJ;ADnmCE;EAAI,sBAAA;ACsmCN;AArcI;EAAQ,0BD3qBF;ACmnCV;AAvcI;EAAS,0BD7qBJ;ACunCT;AAzcI;EAAU,mCAAA;AA4cd;AAzcE;EACE,UAAA;EACA,oBAAA;EACA,YAAA;EACA,cDtrBK;ECurBL,uBAAA;EACA,SAAA;EACA,kBDtrBK;ECurBL,eAAA;AA2cJ;AAzcI;EAAU,cD9rBP;AC0oCP;AA3cI;EAAkB,oCAAA;EAAsC,mBAAA;AA+c5D;AA5cE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,WAAA;AA8cJ;AA3cE;EDnsBA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECyrBE,YAAA;EACA,cAAA;EACA,aAptBC;EAqtBD,qBAAA;EACA,kEAAA;AAmdJ;AD1pCE;EAAI,sBAAA;AC6pCN;AAndE;EDrrBA,kDA3BW;EA4BX,gBAAA;EACA,eCmrBoC;EDlrBpC,iBAAA;EACA,sBAAA;EACA,cAxCK;ECwtBsC,mBA3tBxC;AAurCL;AA3dE;ED7qBA,eAAA;EACA,gBAAA;EACA,cA7CO;ECwtB4B,mBA1tBhC;EA0tBoD,qBAAA;AAkezD;AAjeE;EAAmB,aAAA;EAAe,yBAAA;EAA2B,QA9tB1D;AAosCL;AAreE;EAAW,cAAA;EAAgB,eA/tBxB;EA+tByC,iBAAA;EAAkB,cD3tBzD;EC2tB2E,+BD9tBtE;EC8tBkG,kBDttBrG;ECstBiI,qBAAA;AA8e1I;AA1eE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,2CAAA;EACA,kBDhuBK;ECiuBL,gBAAA;AA4eJ;AAzeE;EAAgB,cAAA;EAAgB,aAAA;AA6elC;AA5eE;EAAmB,WAAA;EAAa,gBAAA;AAgflC;AA9eE;ED5lBA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC4lBE,kBAAA;AAkfJ;AD5kCE;EAAuB,UAAA;AC+kCzB;AD9kCE;EAA6B,oCAAA;EAAsC,kBAAA;ACklCrE;AAvfI;EAAU,aAAA;AA0fd;AAzfI;EAAkB,oCAAA;EAAsC,oBAAA;AA6f5D;AA1fE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kDAAA;EACA,eAAA;AA4fJ;AA1fI;EAAU,qCD/vBD;AC4vCb;AA5fI;EAA0B,qCAAA;AA+f9B;AA5fE;EACE,aAAA;EACA,sEAAA;EACA,mBAAA;EACA,SAtwBC;EAuwBD,YAAA;EACA,eAAA;EACA,kCAAA;AA8fJ;AA5fI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cD1wBG;EC2wBH,qCDjxBO;ECkxBP,kDAAA;EACA,UAAA;AA8fN;AA3fI;EAAc,mCAAA;EAAqC,qCAAA;AA+fvD;AA9fI;EAAgC,cDjxB3B;ACkxCT;AA9fE;EAAS,iBAAA;EAAmB,kCAAA;AAkgB9B;AAhgBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SA/xBC;EAgyBD,YAAA;EACA,eAAA;AAkgBJ;AA/fE;EAAW,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,YAAA;AAqgB9D;AAngBE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,mBDvyBK;AC4yCT;AAngBI;EAAY,mBDvyBN;AC6yCV;AAngBE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAqgBJ;AAngBI;EAAU,gBAAA;AAsgBd;AArgBI;EAAW,cDrzBN;ECqzB0B,eAAA;AAygBnC;AAtgBE;EAAiB,cDxzBV;ECwzB8B,eAAA;AA0gBvC;AAtgBE;EACE,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,UAAA;AAwgBJ;AAtgBI;EAAY,2CAAA;AAygBhB;AAtgBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAwgBJ;AArgBE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gDAAA;EACA,sCAAA;EACA,uEAAA;AAugBJ;AApgBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SA91BC;EA+1BD,uBAAA;EACA,kDAAA;EACA,UAAA;AAsgBJ;AAngBE;EAAe,YAAA;AAsgBjB;AArgBE;ED/zBA,kDA3BW;EA4BX,gBAAA;EACA,eC6zBoC;ED5zBpC,iBAAA;EACA,sBAAA;EACA,cAxCK;ECk2BsC,aAAA;EAAe,mBAAA;EAAqB,SAr2B5E;EAq2BsF,sBAAA;AAihB3F;AAhhBE;EAAkB,eAv2Bf;EAu2BgC,eAAA;EAAiB,cDl2B7C;ACu3CT;AAphBE;EDptBA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECktBwC,OAAA;EAAS,aAAA;EAAe,sBAAA;AA4hBlE;AD5uCE;EAAuB,UAAA;AC+uCzB;AD9uCE;EAA6B,oCAAA;EAAsC,kBAAA;ACkvCrE;AAjiBE;EAAW,eAAA;EAAgB,kDAAA;AAqiB7B;AAriBiE;EAAe,gBAAA;AAwiBhF;AAviBE;EAAiB,mBA12Bd;EA02BkC,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAA2B,cDr2BpH;ACo5CT;AA7iBE;EACE,aAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;AA+iBJ;AA7iBI;EAAK,cD72BA;AC65CT;AA/iBI;EAAK,cDh3BF;ECg3BoB,sBAAA;AAmjB3B;AAjjBI;EAAU,2CAAA;AAojBd;AAjjBE;EAAU,qBAAA;EAAuB,eAAA;AAqjBnC;AAnjBE;EAAU,cAAA;AAsjBZ;AArjBE;EAAgB,cAAA;EAAgB,kBA53B7B;ED4DH,eAAA;EACA,gBAAA;EACA,cAzDO;ACm7CT;AA3jBE;EAAc,aAAA;EAAe,QA73B1B;EA63BoC,mBAAA;AAgkBzC;AAhkB8D;EAAsB,OAAA;EAAS,YAAA;AAokB7F;AAhkBE;EDh2BA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;EC03BL,aAj4BC;AAq8CL;AAlkBI;EAAU,mBAn4BT;AAw8CL;AAlkBE;EAAkB,gBAAA;AAqkBpB;AApkBE;EAAc,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAv4B/E;EAu4ByF,eAAA;AA2kB9F;AA1kBE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,kBA34BhD;AA09CL;AA9kBE;EAAW,aAAA;EAAe,4DAAA;EAA8D,SA14BrF;EA04B+F,kBA34B/F;AA+9CL;AAllBE;EDj1BA,eAAA;EACA,gBAAA;EACA,cAzDO;AC+9CT;AArlBE;EDx2BA,kDA3BW;EA4BX,gBAAA;EACA,eCs2BoC;EDr2BpC,iBAAA;EACA,sBAAA;EACA,cAxCK;EC24BsC,eAh5BxC;EAg5ByD,aAAA;EAAe,mBAAA;EAAqB,SA94B7F;EA84BuG,eAAA;AAkmB5G;AAjmBE;EAAmB,gBA94BhB;AAk/CL;AAlmBE;EAAe,aAAA;EAAe,2DAAA;EAA6D,SAj5BxF;AAw/CL;AArmBE;EDn3BA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;EC64BL,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QA15BC;EA25BD,aAx5BC;EAy5BD,yDD94BQ;EC+4BR,gBAAA;EACA,cDz5BG;ACkgDP;AAvmBI;EACE,eAAA;EACA,yDAAA;AAymBN;AAvmBM;EAAyB,qCAAA;EAAuC,8BAAA;AA2mBtE;AA1mBM;EAA0B,sBAAA;AA6mBhC;AA5mBM;EAAkB,oCAAA;EAAsC,mBAAA;AAgnB9D;AA/mBM;EAAa,eAAA;AAknBnB;AA/mBI;EAAW,8BAAA;AAknBf;AA/mBE;EDr4BA,kDA3BW;EA4BX,gBAAA;EACA,eCm4BmC;EDl4BnC,iBAAA;EACA,sBAAA;EACA,cAxCK;ECw6BqC,wBAAA;EAA0B,kCAAA;AAynBtE;AAznB0G;EAAU,eAAA;EAAiB,cAAA;EAAgB,sBAAA;AA8nBrJ;AA7nBE;EAAe,eAAA;EAAiB,cDv6BzB;ACwiDT;AA/nBE;EAAe,aAAA;EAAe,4DAAA;EAA8D,SA96BzF;AAkjDL;AAloBE;ED92BA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ECi2BE,8BAAA;EACA,aAl7BC;EAm7BD,eAAA;EACA,gBAAA;EACA,yDAAA;AAmpBJ;ADt/CE;EAAyB,qCAAA;EAAuC,8BAAA;AC0/ClE;ADz/CE;EAA0B,0BAAA;AC4/C5B;AD3/CE;EAAa,YAAA;EAAc,mBAAA;AC+/C7B;AD9/CE;EAAkB,oCAAA;EAAsC,mBAAA;ACkgD1D;AAhqBI;EAAY,8BAAA;AAmqBhB;AAnqBgD;EAA2B,wBAAA;AAsqB3E;AAnqBE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cDt7B5C;AC8lDT;AAtqBE;EAAe,kBA97BZ;AAumDL;AAxqBE;EACE,aAAA;EACA,+DAAA;EACA,mBAAA;EACA,SAl8BC;EAm8BD,WAAA;EACA,YAr8BC;EAs8BD,yDDz7BQ;EC07BR,cDn8BG;ECo8BH,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,kDAAA;EACA,eAAA;AA0qBJ;AAxqBI;EAAU,qCD98BD;ACynDb;AA1qBI;EAAkB,oCAAA;EAAsC,oBAAA;AA8qB5D;AA3qBE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAp9BC;EAq9BD,gBAAA;EACA,kDAAA;EACA,eAAA;AA6qBJ;AA3qBI;EAAqC,cDp9BhC;ACkoDT;AA3qBE;EAAY,gBAAA;EAAkB,cAAA;AA+qBhC;AA/qBgD;EAAU,YAAA;AAkrB1D;AAjrBE;EAAiB,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EAAgC,SA79BpF;AAopDL;AAtrBE;EAAiB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SA99BlF;EA89B4F,eAAA;EAAiB,iBA/9B7G;EA+9B+H,+CAAA;AA+rBpI;AA9rBE;EAAkB,OAAA;EAAS,gBAAA;AAksB7B;AAjsBE;EAAe,aAAA;EAAe,sBAAA;EAAwB,QAn+BnD;EAm+B6D,kBAl+B7D;AAyqDL;AAtsBE;EAAc,WAAA;EAAa,iBAAA;EAAkB,yDDt9BnC;ECs9BgE,eAAA;EAAiB,gBAAA;EAAkB,cD99BtG;EC89B0H,uBAAA;EAAyB,2CAAA;EAA6B,kBD19BhL;EC09B4M,eAAA;AAktBrN;AAltBsO;EAAU,cD/9BzO;EC+9B2P,qCAt9BrP;EAs9B8Q,8BAAA;AAutB3R;AAvtB6T;EAAkB,oCAAA;EAAsC,mBAAA;AA2tBrX;AA1tBE;EAAc,aAAA;EAAe,mBAAA;EAAqB,QAp+B/C;AAmsDL;AA/tB8D;EAAO,YAAA;EAAc,uBAAA;AAmuBnF;AAluBE;EAAa,oBAAA;EAAsB,UAAA;EAAY,YAt+B5C;EAs+B0D,cDh+BtD;ECg+B0E,uBAAA;EAAyB,2CAAA;EAA6B,kBD59BhI;EC49B4J,eAAA;AA4uBrK;AA5uBsL;EAAU,cDj+BzL;ECi+B2M,8BAAA;AAgvBlN;AAhvBoP;EAAkB,oCAAA;EAAsC,mBAAA;AAovB5S;AAnvBE;EAAiB,kBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;EAAuB,sBAAA;AA0vBhG;AAxvBE;EAAU,gBAAA;AA2vBZ;AA1vBE;EAAe,aAAA;EAAe,yBAAA;EAA2B,eA1+BtD;AAyuDL;AA9vBE;EAAkB,aAAA;EAAe,yBAAA;EAA2B,gBAv+BzD;AA0uDL;AA/vBE;EAAW,gBAAA;AAkwBb;AAhwBE;EACE,aAAA;EACA,QAn/BC;EAo/BD,mBAj/BC;EAk/BD,kDAAA;EACA,UAAA;AAkwBJ;AA/vBE;ED/0BA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAjKU;EAkKV,eAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;ECq0BE,iBAAA;AA6wBJ;ADhlDE;EAAU,cAnLL;ACswDP;ADllDE;EAAkB,oCAAA;EAAsC,oBAAA;ACslD1D;AAlxBI;EDh0BF,wBAAA;EACA,qCAAA;ACqlDF;AAnxBE;EAAc,aAAA;EAAe,sBAAA;EAAwB,OAAA;EAAS,aAAA;AAyxBhE;AAvxBE;EACE,aAAA;EACA,SAhgCC;EAigCD,OAAA;EACA,aAAA;AAyxBJ;AAtxBE;EDp3BA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECk3BoC,OAAA;EAAS,YAAA;EAAc,aAAA;EAAe,kBAxgCvE;AAuyDL;AD/oDE;EAAuB,UAAA;ACkpDzB;ADjpDE;EAA6B,oCAAA;EAAsC,kBAAA;ACqpDrE;AAryBE;EAAyC,qCAAA;AAwyB3C;AAtyBE;EAAoB,qCAAA;EAAuC,gBAAA;AA0yB7D;AAzyBE;EAAoB,4DAAA;AA4yBtB;AA3yBE;EAAkB,4DAAA;AA8yBpB;AA7yBE;EAAuC,qCAAA;AAgzBzC;AA9yBE;EACE,kBAAA;EACA,aAAA;EACA,qCDnhCS;ECohCT,2CAAA;EACA,kBD5gCK;AC4zDT;AA9yBI;EAAU,8BAAA;AAizBd;AAhzBI;EAAY,8BAAA;EAAgC,qCAAA;AAozBhD;AAnzBI;EAAkC,YAAA;AAszBtC;AAnzBE;EAAiB,UAAA;EAAY,WAAA;EAAa,YAAA;EAAc,qBAAA;EAAqB,8BAAA;EAAgC,eAAA;AA2zB/G;AAzzBE;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,QAliCC;EAmiCD,YAAA;EACA,4BAAA;EACA,yDDxhCQ;ECyhCR,gBAAA;EACA,cDniCG;ECoiCH,uBAAA;EACA,SAAA;EACA,kBDjiCK;ECkiCL,eAAA;AA2zBJ;AAzzBI;EAAkB,oCAAA;EAAsC,oBAAA;AA6zB5D;AA1zBE;EAAe,aAAA;EAAe,mBAAA;EAAqB,QAhjChD;AA+2DL;AA9zBE;EAAgB,OAAA;EAAS,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;AAu0B1H;AAt0BE;EAAgB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,aAAA;AA40BvE;AA30BE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cD7iC5C;EC6iCgE,sBAAA;AAi1BzE;AA/0BE;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,yDD5iCQ;EC6iCR,gBAAA;EACA,cDvjCG;ECwjCH,qCD5jCS;EC6jCT,2CAAA;EACA,kBDrjCK;ECsjCL,gBAAA;EACA,eAAA;AAi1BJ;AA/0BI;EAAU,8BAAA;AAk1Bd;AAj1BI;EAAkB,oCAAA;EAAsC,mBAAA;AAq1B5D;AAp1BI;EAAY,8BAAA;EAAgC,qCAAA;AAw1BhD;AAr1BE;EAAe,UAAA;EAAY,UAAA;AAy1B7B;AAx1BE;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAzkCpD;EAykC8D,kBAAA;EAAkB,YAAA;AA+1BrF;AA91BE;EAAe,aAAA;EAAe,mBAAA;EAAqB,QAzkChD;AA46DL;AAl2BE;EAAgB,eAAA;EAAiB,gBAAA;AAs2BnC;AAr2BE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cDtkC5C;ACg7DT;AAz2BE;EAAgB,eAAA;EAAiB,cDtkC1B;ACm7DT;AA32BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAllCC;EAmlCD,iBAAA;EACA,qCAAA;EACA,kCAAA;EACA,kBD9kCK;EC+kCL,kEAAA;AA62BJ;AA12BE;EAAe,eAAA;EAAiB,gBAAA;EAAkB,wBAAA;AA+2BpD;AA92BE;EAAe,oBAAA;EAAsB,mBAAA;EAAqB,QA5lCvD;AA+8DL;AAj3BE;EAAe,gBAAA;EAAkB,2CAAA;EAA6B,kBDrlCvD;AC28DT;AAp3BE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAs3BJ;AAp3BI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDpmCG;ECqmCH,mBAAA;EACA,qCD5mCO;EC6mCP,kDAAA;AAs3BN;AAn3BI;EAAK,iBAAA;EAAkB,sBAAA;EAAwB,kDAAA;AAw3BnD;AAv3BI;EAAW,eAAA;AA03Bf;AAz3BI;EAAiB,qCDlnCR;AC8+Db;AA33BI;EAAqB,qCAAA;EAAuC,0CAAA;AA+3BhE;AA93BI;EAAqB,YAAA;AAi4BzB;AAh4BI;EAAoB,iBAAA;AAm4BxB;AAh4BE;EAAmC,aAAA;AAm4BrC;AAl4BE;EAAe,WAAA;AAq4BjB;AAn4BE;EACE,oBAAA;EACA,mBAAA;EACA,QA9nCC;EA+nCD,UAAA;EACA,yDDnnCQ;EConCR,eAAA;EACA,gBAAA;EACA,cD/nCG;ECgoCH,uBAAA;EACA,SAAA;EACA,eAAA;AAq4BJ;AAn4BI;EAAkB,oCAAA;EAAsC,mBAAA;AAu4B5D;AAp4BE;EAAY,eA3oCT;AAkhEL;AAt4BE;EAAW,aAAA;EAAe,mBAAA;EAAqB,SA3oC5C;EA2oCsD,gBAAA;EAAkB,kDAAA;AA64B7E;AA14BE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YA3oCO;EA4oCP,aAAA;EACA,0CAAA;EACA,kBD7oCK;EC8oCL,qCAAA;EACA,uEAAA;AA44BJ;AAz4BE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SA9pCC;EA+pCD,uBAAA;EACA,kDAAA;EACA,UAAA;AA24BJ;AAx4BE;EAAe,YAAA;AA24BjB;AA14BE;ED/nCA,kDA3BW;EA4BX,gBAAA;EACA,eC6nCqC;ED5nCrC,iBAAA;EACA,sBAAA;EACA,cAxCK;ECkqCuC,sBAAA;AAm5B9C;AAl5BE;EAAgB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,aAAA;EAAc,eAvqChF;AAgkEL;AAx5BE;EDphCA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECkhCwC,OAAA;EAAS,aAAA;EAAe,oBAAA;AAg6BlE;ADh7DE;EAAuB,UAAA;ACm7DzB;ADl7DE;EAA6B,oCAAA;EAAsC,kBAAA;ACs7DrE;AAr6BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SA7qCC;EA8qCD,kBAAA;EACA,+CAAA;EACA,UAAA;AAu6BJ;AAp6BE;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAnrClD;AA4lEL;AAx6BE;EAAW,eAAA;EAAiB,wBAAA;AA46B9B;AA16BE;EAAU,eAAA;EAAgB,kDAAA;AA86B5B;AA96BgE;EAAe,gBAAA;AAi7B/E;AAh7BE;EAAgB,kBAzrCb;EAyrCiC,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAA2B,cDlrCnH;AC0mET;AAt7BE;EAAe,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAxrChF;EAwrC0F,eA1rC1F;AAunEL;AA57BE;EAAY,aAAA;EAAe,eAAA;EAAiB,mBAAA;EAAqB,QA3rC9D;AA6nEL;AAj8BE;EAA+B,SAAA;AAo8BjC;AAn8BE;EAAc,aAAA;EAAe,mBAAA;EAAqB,SA5rC/C;AAooEL;AAt8BE;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAhsCpD;EAgsC8D,gBA9rC9D;EA8rC+E,iBAAA;EAAmB,gBAAA;AA88BvG;AA58BE;EACE,aAAA;EACA,mBAAA;EACA,SAnsCC;EAosCD,WAAA;EACA,iBAAA;EACA,yDD1rCQ;EC2rCR,cDpsCG;ECqsCH,gBAAA;EACA,qCD1sCS;EC2sCT,2CAAA;EACA,kBDnsCK;ECosCL,eAAA;AA88BJ;AA58BI;EAAU,qCAAA;EAAuC,8BAAA;AAg9BrD;AA/8BI;EAAkB,oCAAA;EAAsC,mBAAA;AAm9B5D;AAh9BE;EAAY,kBAAA;EAAmB,2CAAA;EAA6B,kBD1sCrD;AC+pET;AAn9BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAxtCC;EAytCD,aAztCC;EA0tCD,kDAAA;AAq9BJ;AAn9BI;EAAe,gBAAA;AAs9BnB;AAr9BI;EAAQ,qCAAA;AAw9BZ;AAr9BE;EAAiB,OAAA;EAAS,YAAA;AAy9B5B;AAx9BE;EAAkB,eAAA;EAAiB,gBAAA;AA49BrC;AA39BE;EAAiB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,cD7tC9D;AC8rET;AA/9BE;EAAS,oBAAA;EAAsB,UAAA;EAAY,0CAAA;EAAoC,kBD5tCxE;EC4tCoG,gBAAA;AAs+B7G;AAp+BE;EACE,gBAAA;EACA,yDD5tCQ;EC6tCR,eAAA;EACA,gBAAA;EACA,cDvuCK;ECwuCL,uBAAA;EACA,SAAA;EACA,iDAAA;EACA,eAAA;AAs+BJ;AAp+BI;EAAe,eAAA;AAu+BnB;AAt+BI;EAAwD,cD/uCrD;EC+uCuE,qCAtuCjE;AAgtEb;AAz+BI;EAAa,aAAA;EAAe,mBAAA;AA6+BhC;AA5+BI;EAAkB,oCAAA;EAAsC,oBAAA;AAg/B5D;AA9+BI;EAAQ,cDnvCL;ECmvCuB,oCAzuChB;AA2tEd;AAj/BI;EAAiB,cDhvCX;ECgvCgC,qCA7uChC;AAkuEV;AAp/BI;EAAkB,cDlvCb;ECkvCiC,qCA7uC5B;AAquEd;AAr/BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cD7vCK;EC8vCL,2CAAA;EACA,kBD5vCK;ACmvET;AAr/BI;EAAQ,cD/vCF;EC+vCuB,qBD/vCvB;EC+vCmD,qCA5vCnD;AAsvEV;AAv/BE;EAAiB,aAAA;EAAe,uBAAA;EAAyB,SAzwCtD;EAywCgE,gBAzwChE;AAswEL;AA5/BE;EAAkB,UAAA;EAAY,WAAA;EAAa,gBAAA;EAAkB,eAAA;EAAiB,cDrwCvE;ACwwET;AAlgCE;EAAc,aAAA;EAAe,eAAA;EAAiB,YAAA;AAugChD;AAtgCE;EAAgC,cAAA;AAygClC;AAvgCE;EAAa,aAAA;EAAe,eAAA;EAAiB,QA/wC1C;AA2xEL;AA1gCE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,kBD7wCK;EC8wCL,eAAA;EACA,yDAAA;AA4gCJ;AA1gCI;EAAU,sBAAA;AA6gCd;AA5gCI;EAAkB,oCAAA;EAAsC,mBAAA;AAghC5D;AA/gCI;EAAQ,qBDxxCL;AC0yEP;AA7gCE;EAAc,kBAAA;EAAoB,gBAhyC/B;AAizEL;AAhhCE;EAAa,kBAAA;EAAoB,aAAA;EAAe,SAjyC7C;EAiyCuD,sBAAA;AAshC5D;AArhCE;EAAqB,WAAA;EAAa,kBAAA;EAAoB,SAAA;EAAW,YAAA;EAAc,SAAA;EAAW,UAAA;EAAY,oCDhyC1F;AC8zEd;AA7hCE;EAAgC,aAAA;AAgiClC;AA/hCE;EAAY,kBAAA;EAAoB,QAAA;EAAU,OAAA;EAAS,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,mBD/xCzF;ACu0ET;AAxiC2H;EAAY,4BAAA;AA2iCvI;AA3iCuK;EAAU,mBD7xCvK;AC20EV;AA9iC6M;EAAU,mBD9xC9M;AC+0ET;AAhjCE;EAAa,YAAA;AAmjCf;AAljCE;EAAc,eAAA;EAAiB,gBAAA;AAsjCjC;AArjCE;EAAe,gBAxyCZ;EAwyC8B,gBAAA;EAAkB,wBAAA;AA0jCrD;AAzjCE;EAAe,eAAA;EAAiB,eAAA;EAAiB,iBAAA;EAAmB,cDpyC7D;ACm2ET;AA9jCE;EAAa,eAAA;EAAiB,eAAA;EAAiB,cDpyCxC;ACu2ET;AAlkCE;EAAqB,eA3yClB;AAg3EL;AApkCE;EAAgC,oBA3yC7B;AAk3EL;AAnkCE;ED5pCA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC0pC8D,OAAA;EAAS,aAAA;EAAe,kBAhzCnF;AA23EL;ADnuEE;EAAuB,UAAA;ACsuEzB;ADruEE;EAA6B,oCAAA;EAAsC,kBAAA;ACyuErE;AAhlCE;EAAY,aAAA;EAAe,eAAA;EAAiB,SAjzCzC;EAizCmD,eAAA;EAAiB,cD7yChE;ACo4ET;AAvlC6F;EAAK,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;AA4lC7I;AA1lCE;EAAuB,gBAnzCpB;AAg5EL;AA3lCE;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AA6lCJ;AA3lCI;EAAS,YA5zCR;EA4zCsB,kBAAA;EAAoB,kDAAA;EAAoC,mBAAA;AAimCnF;AAhmCI;EAAW,gBAAA;EAAkB,MAAA;EAAQ,UAAA;EAAY,gBAAA;EAAkB,cDxzC9D;ECwzCkF,2BAAA;AAwmC3F;AAvmCI;EAA6B,aAAA;AA0mCjC;AAzmCI;EAAuC,qCD/zC9B;AC26Eb;AA3mCI;EAAqB,gBAAA;EAAkB,2BAAA;EAAiC,gBAAA;AAgnC5E;AA7mCE;EAAkB,gBAAA;EAAkB,OAAA;EAAS,UAAA;EAAY,gBAAA;EAAkB,2BAAA;EAA6B,2BAAA;AAqnC1G;AApnCE;EAAkC,UAAA;EAAY,2BAAA;AAwnChD;AAvnCE;EAAW,cAAA;EAAgB,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,cDj0C7E;AC+7EP;AA7nCE;EAAkB,kCAAA;EAAoC,wBAAA;AAioCxD;AA/nCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cDz0CK;EC00CL,uBAAA;EACA,2CAAA;EACA,kBDz0CK;EC00CL,eAAA;EACA,wDAAA;AAioCJ;AA/nCI;EAAU,8BAAA;AAkoCd;AAjoCI;EAAW,qBAAA;AAooCf;AAnoCI;EAAkB,oCAAA;EAAsC,mBAAA;AAuoC5D;AAtoCI;EAAgB,wBAAA;EAA0B,8BAAA;AA0oC9C;AAzoCI;EAAS,cDh1CD;ECg1CwB,4BAAA;EAA8B,8BAAA;AA8oClE;AA7oCI;EAAU,cDp1CL;ECo1CyB,qBDp1CzB;ECo1CoD,qCA/0C/C;AAi+Ed;AA7oCE;EAAU,gBAAA;EAAkB,oBA71CzB;EA61C8C,mBA71C9C;EA61CkE,kDAAA;AAmpCvE;AAnpC2G;EAAe,gBAAA;AAspC1H;AArpCE;ED1zCA,kDA3BW;EA4BX,gBAAA;EACA,eCwzCmC;EDvzCnC,iBAAA;EACA,sBAAA;EACA,cAxCK;EC61CqC,kBAl2CvC;AAggFL;AA7pCE;EAAU,iBAAA;EAAmB,cAAA;EAAe,+CAAA;EAAiD,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AAsqCpJ;AArqCE;EAAe,aAAA;EAAe,eAAA;EAAiB,QAn2C5C;EAm2CsD,cAAA;AA2qC3D;AA1qCE;EAAgB,iBAAA;EAAmB,mBAn2ChC;EAm2CoD,gBAAA;EAAkB,2CAAA;EAA6B,kBD31C/F;AC4gFT;AAhrCE;EAAgB,aAAA;EAAe,SAp2C5B;EAo2CsC,iBAAA;EAAkB,eAAA;EAAiB,kDAAA;AAurC9E;AAvrCkH;EAAe,gBAAA;AA0rCjI;AA1rCqJ;EAAW,cD91CvJ;AC2hFT;AA7rCsL;EAAU,cD/1CvL;AC+hFT;AA/rCE;EAAgB,UAAA;EAAY,WAAA;EAAa,gBAAA;AAosC3C;AAhsCE;EAAU,aAAA;EAAe,sBAAA;EAAwB,aAAA;EAAe,OAAA;AAssClE;AArsCE;EAAa,aAAA;EAAe,mBAAA;EAAqB,SA12C9C;EA02CwD,mBA12CxD;AAqjFL;AAzsCE;EACE,aAAA;EACA,mBAAA;EACA,QAh3CC;EAi3CD,UAAA;EACA,mBAAA;EACA,cD92CK;EC+2CL,eAAA;EACA,eAAA;EACA,iBAAA;AA2sCJ;AAzsCI;EAAQ,WAAA;EAAa,YAAA;EAAc,8BAAA;EAAgC,eAAA;AA+sCvE;AA5sCE;EACE,aAAA;EACA,mBAAA;EACA,SA73CC;EA83CD,iBAAA;EACA,kDAAA;AA8sCJ;AA5sCI;EAAU,gBAn4CT;EAm4C2B,mBAl4C3B;EAk4CgD,cD53C5C;EC43CgE,eAAA;EAAiB,gBAAA;AAmtC1F;AAltCI;EAAc,8BAAA;AAqtClB;AAptCI;EAAa,cD93CR;ACqlFT;AAptCE;EAAsB,cDl4Cf;ACylFT;AAttCE;EDpvCA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECkvC+B,OAAA;EAAS,aAAA;AA6tC1C;AD78EE;EAAuB,UAAA;ACg9EzB;AD/8EE;EAA6B,oCAAA;EAAsC,kBAAA;ACm9ErE;AAnuCE;EAAW,eAAA;EAAgB,cDn4CpB;ECm4CwC,eAAA;AAwuCjD;AAtuCE;EAAU,mBAz4CP;EAy4C2B,kBAAA;EAAkB,2CAAA;EAA6B,kBDl4CtE;ECk4CkG,qCD34C9F;ACwnFb;AA5uCE;EAAe,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SA34ChF;EA24C0F,mBA34C1F;AA8nFL;AAlvCE;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,kCAAA;AAwvC1E;AAvvCE;EAAe,cDx4CR;ECw4C4B,eAAA;AA2vCrC;AA1vCE;EAAc,aAAA;EAAe,eAAA;EAAiB,mBAAA;EAAqB,QA/4ChE;EA+4C0E,eA/4C1E;AAgpFL;AAhwCE;EAAc,OAAA;AAmwChB;AAlwCE;EDzxCA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECixCoC,WAAA;EAAa,kBAAA;AA+wCnD;AD9hFE;EAAU,aAAA;EAAe,8BAAA;ACkiF3B;ADjiFE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACwiF1G;AAxxCE;EAAW,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,mBAl5ClD;AAgrFL;AA5xCE;EDl1CA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;ECoyCE,iBAAA;EACA,yDAAA;AA8yCJ;ADnnFE;EAAyB,qCAAA;EAAuC,8BAAA;ACunFlE;ADtnFE;EAA0B,0BAAA;ACynF5B;ADxnFE;EAAa,YAAA;EAAc,mBAAA;AC4nF7B;AD3nFE;EAAkB,oCAAA;EAAsC,mBAAA;AC+nF1D;AA3zCI;EDh0CF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC8nFF;AD5nFE;EAAyB,6BAAA;EAA+B,+BAAA;ACgoF1D;AAj0CE;EDtyCA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC8xCgC,OAAA;EAAS,WAAA;AA80C3C;AD1mFE;EAAU,aAAA;EAAe,8BAAA;AC8mF3B;AD7mFE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AConF1G;AAx1CE;EDvxCA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;EC+wC+B,iBAAA;AAo2CjC;;AA/1CA;EACE;IAAwB,aAAA;EAm2CxB;AACF;AAj2CA;EACE;IAA6B,aAAA;EAo2C7B;EAn2CA;IAAsB,WAAA;EAs2CtB;EAr2CA;IAAuB,2CAAA;EAw2CvB;EAv2CA;IAAoB,QA56CjB;EAsxFH;EAz2CA;IAAgC,2CAAA;EA42ChC;EA32CA;IAAuB,YAAA;EA82CvB;AACF;AA32CA;EACE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,SAAA;IACA,qCAAA;IACA,4CAAA;EA62CF;EA12CA;IAAoB,eAAA;IAAiB,aAAA;IAAc,aA37ChD;EA0yFH;EA92CA;IAAsB,QAAA;IAAU,eAAA;EAk3ChC;EAj3CA;IAA4B,QAAA;IAAU,iBAAA;EAq3CtC;EAp3CA;IAAwB,QAAA;IAAU,cAAA;IAAgB,eAAA;EAy3ClD;EAx3CA;IAAsB,QAAA;IAAU,eAAA;EA43ChC;EA33CA;IAAiC,eAAA;EA83CjC;EA53CA;IACE,aAAA;IACA,SAn8CC;IAo8CD,iBAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,kDAAA;EA83CF;EA33CA;IAA2B,aAAA;IAAe,mBAAA;IAAqB,QA98C5D;IA88CsE,SAAA;IAAW,UAAA;EAk4CpF;EAj4CA;IAA2B,aAAA;EAo4C3B;EAn4CA;IAAoB,WAAA;IAAa,YAAA;IAAc,SAAA;IAAW,mBAAA;IAAqB,sBAAA;EA04C/E;EAz4CA;IAA4B,yCAAA;EA44C5B;EA14CA;IAAqB,uBAAA;EA64CrB;EA54CA;IAA6B,uBAAA;EA+4C7B;EA94CA;IAAgC,qCAAA;EAi5ChC;EAh5CA;IAAuB,kBAAA;IAAoB,MAAA;IAAQ,OAAA;IAAS,QAAA;IAAU,SAAA;IAAW,UAAA;IAAY,kCAAA;IAAoC,cAAA;EA05CjI;EAz5CA;IAAwB,qCAAA;EA45CxB;EA35CA;IAA0B,sBAAA;IAAwB,gBAAA;EA+5ClD;EA95CA;IAA0B,iBAAA;IAAmB,UAAA;IAAY,gBAAA;EAm6CzD;EAl6CA;IAA0D,aAAA;EAq6C1D;EAp6CA;IAAuB,WAAA;IAAa,OAAA;EAw6CpC;EAv6CA;IAAgF,qCAAA;EA06ChF;EAz6CA;IAAuB,WA39CpB;IA29CgC,YA39ChC;IA29C6C,UA39C7C;IA29CwD,eAAA;EA+6C3D;EA96CA;IAAwB,gBAAA;EAi7CxB;AACF;AA56CE;EAAoB,YAAA;EAAc,eAAA;AAg7CpC;AA/6CE;EAA2B,mBAn+CxB;AAq5FL;AAj7CE;EAAqB,iBAn+ClB;AAu5FL;AAn7CE;EAA0B,mBAr+CvB;AA25FL;AAr7CE;EAA6B,iBAr+C1B;AA65FL;AAv7CE;EAAsB,eAAA;AA07CxB;AAz7CE;EAA2B,QA1+CxB;EA0+CkC,gBAz+ClC;EAy+CoD,mBAz+CpD;AAu6FL;AA77CE;EAA0B,gBA3+CvB;EA2+CyC,mBA3+CzC;AA46FL;AAh8CE;EAA2B,gBA3+CxB;EA2+C0C,mBA3+C1C;AA+6FL;AAn8CE;EAAqB,aA3+ClB;AAi7FL;AAr8CE;EAAqB,eAAA;AAw8CvB;;AAn8CA;EACE;;IAEE,0BAAA;IACA,2BAAA;EAs8CF;EAn8CA;IAAuB,eAAA;EAs8CvB;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Admin panel: a large ink window (92% by 90% of the screen; percentages, not vw/vh, because the whole UI is\n// zoomed by theme/uiScale.ts and viewport units ignore that zoom) with a navigation rail on the left, a top bar\n// (search, server pills, identity) and one view at a time.\n//\n// Language of the project: ink background, 1px light border, one 6px radius, accent only through\n// --gold-main/-light/-dark, Marcellus for titles and Din-pro for the rest, no ornament.\n// Spacing scale: 4 / 8 / 12 / 16 / 24 / 32 only.\n// Motion: transform and opacity only, 150 to 200 ms, one curve; everything is instant under reduced motion.\n// Older CEF in game: no color-mix(), no relative colours, no :has(), no @container, no native nesting,\n// no min()/clamp().\n//\n// The \"legacy\" classes at the end (row, cell, chips, time...) are still used by PlacementTab, SpawnTab\n// and TimeControls.\n\n$s1: 4px;\n$s2: 8px;\n$s3: 12px;\n$s4: 16px;\n$s5: 24px;\n$s6: 32px;\n\n$rail-w: 232px;\n$drawer-w: 400px;\n$editor-w: 520px;\n$ease: cubic-bezier(0.16, 1, 0.3, 1);\n\n$tint-ok: rgba(143, 191, 138, 0.16);\n$tint-danger: rgba(217, 120, 109, 0.16);\n$tint-hover: rgba(255, 255, 255, 0.07);\n$tint-active: rgba(255, 255, 255, 0.1);\n\n@keyframes admin-panel-view-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes admin-panel-slide-in {\n  from { opacity: 0; transform: translateX(16px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes admin-panel-toast-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes admin-panel-pulse {\n  from { opacity: 0.35; }\n  to { opacity: 0.75; }\n}\n\n@keyframes admin-panel-progress {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(260%); }\n}\n\n.admin-panel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ink.$font-text;\n  color: ink.$text;\n  z-index: 50;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: opacity 0.18s $ease;\n\n  &--open { opacity: 1; }\n\n  * { box-sizing: border-box; }\n\n  h2, h3, h4, p, ul, dl, dd { margin: 0; padding: 0; }\n  ul { list-style: none; }\n\n  &__sr {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n  }\n\n  &__icon { flex: none; display: block; }\n\n  &__window {\n    @include ink.panel;\n    // A blur over a window this large costs frames in the embedded browser\n    backdrop-filter: none;\n    background: rgba(11, 15, 19, 0.985);\n    position: relative;\n    width: 92%;\n    height: 90%;\n    max-width: 2200px;\n    display: grid;\n    grid-template-columns: $rail-w minmax(0, 1fr);\n    grid-template-rows: auto minmax(0, 1fr);\n    overflow: hidden;\n    transform: translateY(12px) scale(0.985);\n    transition: transform 0.2s $ease;\n  }\n\n  &--open &__window { transform: none; }\n\n  // ---- progress: a thin bar while a request waits for the server -----------\n\n  &__progress {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    overflow: hidden;\n    z-index: 30;\n    opacity: 0;\n    transition: opacity 0.15s $ease;\n    pointer-events: none;\n\n    &--on { opacity: 1; }\n  }\n\n  &__progress-bar {\n    display: block;\n    width: 38%;\n    height: 100%;\n    background: var(--gold-main);\n    animation: admin-panel-progress 1.1s linear infinite;\n  }\n\n  // ---- top bar -------------------------------------------------------------\n\n  &__top {\n    grid-column: 1 / -1;\n    display: flex;\n    align-items: center;\n    gap: $s4;\n    padding: $s3 $s5 $s3 $s4;\n    border-bottom: 1px solid ink.$line;\n    background: ink.$ink-raised;\n  }\n\n  &__brand { flex: none; width: $rail-w - $s5 - $s4; padding-left: $s2; }\n  &__title { @include ink.title(22px); white-space: nowrap; }\n\n  &__gsearch {\n    position: relative;\n    flex: 1 1 280px;\n    min-width: 160px;\n    max-width: 480px;\n  }\n\n  &__gsearch-icon { position: absolute; top: 50%; left: $s3; margin-top: -8px; color: ink.$text-3; pointer-events: none; }\n  &__gsearch &__search-input { width: 100%; padding-left: 36px; padding-right: 36px; }\n\n  &__kbd {\n    position: absolute;\n    top: 50%;\n    right: $s2;\n    margin-top: -10px;\n    min-width: 20px;\n    padding: 1px 6px;\n    font-family: ink.$font-text;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: center;\n    color: ink.$text-3;\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    pointer-events: none;\n  }\n\n  &__search-results {\n    @include ink.panel;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    margin-top: $s2;\n    padding: $s1;\n    z-index: 20;\n    max-height: 420px;\n    overflow-y: auto;\n  }\n\n  &__search-empty { padding: $s3; color: ink.$text-3; font-size: 14px; }\n\n  &__search-hit {\n    display: flex;\n    align-items: center;\n    gap: $s3;\n    padding: $s2 $s3;\n    border-radius: ink.$radius;\n    cursor: pointer;\n\n    &--active { background: $tint-active; }\n  }\n\n  &__pills {\n    display: flex;\n    align-items: center;\n    flex: none;\n  }\n\n  &__pill {\n    display: inline-flex;\n    align-items: baseline;\n    gap: $s2;\n    padding: 0 $s3;\n    white-space: nowrap;\n    border-left: 1px solid ink.$line;\n\n    &:first-child { border-left: 0; }\n    &--alert .admin-panel__pill-value { color: ink.$danger; }\n  }\n\n  &__pill-label { font-size: 12px; font-weight: 600; color: ink.$text-3; }\n  &__pill-value { font-size: 14px; font-weight: 600; color: ink.$text; font-variant-numeric: tabular-nums; }\n\n  &__top-actions { display: flex; align-items: center; gap: $s2; flex: none; margin-left: auto; }\n  &__updated { margin-right: $s2; font-size: 13px; color: ink.$text-3; white-space: nowrap; }\n\n  &__iconbtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    color: ink.$text-2;\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: transform 0.12s $ease;\n\n    &:hover:not(:disabled) { color: ink.$text; background: $tint-hover; }\n    &:active:not(:disabled) { transform: scale(0.94); }\n    &:disabled { opacity: 0.4; cursor: not-allowed; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 1px; }\n    &--active { color: var(--gold-light); border-color: ink.$line-strong; background: $tint-hover; }\n  }\n\n  &__iconbtns { display: inline-flex; gap: $s1; }\n\n  &__identity { position: relative; flex: none; }\n\n  &__identity-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0;\n    height: 36px;\n    padding: 0 $s3;\n    justify-content: center;\n    font-family: ink.$font-text;\n    color: ink.$text;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: transform 0.12s $ease;\n\n    &:hover { background: $tint-active; border-color: var(--gold-dark); }\n    &:active { transform: scale(0.98); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n  }\n\n  &__role { font-size: 13px; font-weight: 600; line-height: 1.2; color: ink.$text; }\n  &__role--owner { color: var(--gold-light); }\n  &__identity-sub { font-size: 12px; line-height: 1.2; color: ink.$text-3; }\n\n  &__popover {\n    @include ink.panel;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    width: 300px;\n    margin-top: $s2;\n    padding: $s4;\n    z-index: 20;\n    animation: admin-panel-toast-in 0.16s $ease;\n  }\n\n  &__popover-title { @include ink.label; margin-bottom: $s3; }\n  &__perm-list { display: grid; grid-template-columns: 1fr 1fr; gap: $s2 $s3; margin-bottom: $s3; }\n\n  &__perm {\n    display: flex;\n    align-items: center;\n    gap: $s2;\n    font-size: 13px;\n    color: ink.$text-3;\n\n    &--on { color: ink.$text; .admin-panel__icon { color: ink.$success; } }\n  }\n\n  // ---- navigation rail -----------------------------------------------------\n\n  &__rail {\n    @include ink.scroll;\n    padding: $s4 $s3 $s5;\n    border-right: 1px solid ink.$line;\n    min-height: 0;\n  }\n\n  &__rail-group { margin-bottom: $s4; }\n\n  &__rail-title {\n    padding: 0 $s3 $s2;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: ink.$text-3;\n  }\n\n  &__nav {\n    display: flex;\n    align-items: center;\n    gap: $s3;\n    width: 100%;\n    height: 38px;\n    padding: 0 $s3;\n    margin-bottom: 2px;\n    font-family: ink.$font-text;\n    font-size: 15px;\n    font-weight: 600;\n    text-align: left;\n    color: ink.$text-2;\n    background: transparent;\n    border: 1px solid transparent;\n    border-left: 2px solid transparent;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: transform 0.12s $ease;\n\n    &:hover { color: ink.$text; background: $tint-hover; }\n    &:active { transform: scale(0.985); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n    &--active {\n      color: var(--gold-light);\n      background: $tint-active;\n      border-left-color: var(--gold-main);\n    }\n  }\n\n  &__nav-label { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n  &__nav-badge {\n    @include ink.badge;\n    flex: none;\n\n    &--warn { color: ink.$on-accent; background: var(--gold-main); }\n  }\n\n  // ---- main area -----------------------------------------------------------\n\n  &__main {\n    position: relative;\n    min-width: 0;\n    min-height: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__viewwrap {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    animation: admin-panel-view-in 0.18s $ease both;\n  }\n\n  &__view {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    padding: $s5 $s5 $s4;\n\n    &--scroll {\n      @include ink.scroll;\n      display: block;\n    }\n  }\n\n  &__view-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: $s4;\n    margin-bottom: $s4;\n    flex: none;\n  }\n\n  &__view-title { @include ink.title(24px); }\n  &__view-sub { margin-top: $s1; font-size: 14px; line-height: 1.5; color: ink.$text-2; }\n  &__view-tools { display: flex; align-items: center; gap: $s2; flex: none; }\n\n  &__toolbar {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: $s2 $s3;\n    margin-bottom: $s3;\n    flex: none;\n\n    &--tight { margin-bottom: $s3; }\n  }\n\n  &__scroll {\n    @include ink.scroll;\n    flex: 1;\n    min-height: 0;\n    padding-right: $s1;\n  }\n\n  &__section { margin-top: $s5; padding-top: $s4; border-top: 1px solid ink.$line; }\n  &__columns { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 $s6; }\n\n  // ---- form controls -------------------------------------------------------\n\n  &__input {\n    @include ink.field;\n    width: auto;\n    color-scheme: dark;\n\n    &--grow { flex: 1 1 220px; min-width: 160px; }\n    &--block { display: block; width: 100%; }\n    &--xs { width: 72px; padding: 5px $s2; text-align: center; }\n    &[aria-invalid='true'] { border-color: ink.$danger; }\n    &[readonly] { color: ink.$text-2; }\n  }\n\n  &__searchfield { position: relative; }\n  &__searchfield-icon { position: absolute; top: 50%; left: $s3; margin-top: -7px; color: ink.$text-3; pointer-events: none; }\n  &__searchfield &__input { padding-left: 34px; }\n\n  &__textarea { width: 100%; min-height: 96px; resize: vertical; line-height: 1.45; &--short { min-height: 64px; } }\n\n  &__select-wrap { display: inline-flex; align-items: center; gap: $s2; }\n  &__select-label { font-size: 13px; font-weight: 600; color: ink.$text-2; }\n\n  &__select {\n    @include ink.field;\n    width: auto;\n    padding: 8px $s3;\n    cursor: pointer;\n    color-scheme: dark;\n\n    &--block { flex: 1; width: 100%; }\n    &--sm { padding: 5px $s2; font-size: 13px; }\n  }\n\n  &__field-label {\n    display: block;\n    margin: $s4 0 $s2;\n    @include ink.label;\n\n    &--first { margin-top: 0; }\n  }\n\n  &__check {\n    display: inline-flex;\n    align-items: center;\n    gap: $s2;\n    margin-left: auto;\n    font-size: 14px;\n    color: ink.$text-2;\n    cursor: pointer;\n    user-select: none;\n\n    input { width: 16px; height: 16px; accent-color: var(--gold-main); cursor: pointer; }\n  }\n\n  // ---- buttons -------------------------------------------------------------\n\n  &__button {\n    @include ink.button;\n    @include ink.button-sm;\n    padding: 7px $s3;\n    transition: transform 0.12s $ease;\n\n    &--primary { @include ink.button-primary; }\n    &--secondary { @include ink.button-quiet; }\n    &--danger { @include ink.button-danger; }\n    &--sm { padding: 5px $s2; }\n    &--on { border-color: var(--gold-main); color: var(--gold-light); }\n\n    &--danger-solid {\n      color: ink.$on-accent;\n      background: ink.$danger;\n      border-color: ink.$danger;\n\n      &:hover:not(:disabled) { background: #e48c82; border-color: #e48c82; }\n    }\n  }\n\n  &__empty-action { margin-top: $s4; }\n\n  &__linkbtn {\n    margin-left: $s2;\n    padding: 2px $s1;\n    font-family: ink.$font-text;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--gold-light);\n    background: transparent;\n    border: 0;\n    border-radius: 3px;\n    cursor: pointer;\n\n    &:hover { text-decoration: underline; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 1px; }\n    &--flush { margin-left: 0; }\n  }\n\n  &__btnrow { display: flex; flex-wrap: wrap; align-items: center; gap: $s2; }\n\n  &__switch {\n    position: relative;\n    flex: none;\n    width: 42px;\n    height: 24px;\n    padding: 0;\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid ink.$line-strong;\n    border-radius: 12px;\n    cursor: pointer;\n\n    &:hover:not(:disabled) { border-color: var(--gold-dark); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n    &:disabled { opacity: 0.4; cursor: not-allowed; }\n\n    &--on { background: var(--gold-main); border-color: var(--gold-main); }\n  }\n\n  &__switch-knob {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: ink.$text;\n    transition: transform 0.16s $ease;\n  }\n  &__switch--on &__switch-knob { transform: translateX(18px); background: ink.$on-accent; }\n\n  &__segmented {\n    display: inline-flex;\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    overflow: hidden;\n  }\n\n  &__seg {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 7px $s3;\n    font-family: ink.$font-text;\n    font-size: 14px;\n    font-weight: 600;\n    color: ink.$text-2;\n    background: transparent;\n    border: 0;\n    border-right: 1px solid ink.$line;\n    cursor: pointer;\n\n    &:last-child { border-right: 0; }\n    &:hover { color: ink.$text; background: $tint-hover; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n    &--active { color: ink.$on-accent; background: var(--gold-main); &:hover { color: ink.$on-accent; background: var(--gold-light); } }\n  }\n\n  &__seg-count { font-size: 12px; font-weight: 600; opacity: 0.8; }\n\n  // ---- states --------------------------------------------------------------\n\n  &__empty-state { padding: $s6 $s4; text-align: center; }\n  &__empty-title { font-size: 16px; font-weight: 600; color: ink.$text-2; }\n  &__empty-text { @include ink.hint; max-width: 460px; margin: $s2 auto 0; }\n\n  &__skeleton { padding: $s2 0; }\n  &__skeleton--stats { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: $s3; }\n  &__skeleton--cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: $s3; }\n\n  &__skel {\n    display: block;\n    height: 12px;\n    background: rgba(255, 255, 255, 0.12);\n    border-radius: ink.$radius;\n    animation: admin-panel-pulse 0.9s ease-in-out infinite alternate;\n\n    &--label { width: 40%; height: 10px; }\n    &--value { width: 30%; height: 26px; margin: $s2 0; }\n    &--line { height: 12px; margin-bottom: $s2; }\n    &--dot { width: 8px; height: 8px; border-radius: 50%; flex: none; }\n    &--grow { flex: 1; }\n    &--field { height: 34px; margin-bottom: $s3; }\n  }\n\n  &__skel-stat, &__skel-card { padding: $s4; border: 1px solid ink.$line; border-radius: ink.$radius; background: ink.$ink-raised; }\n  &__skel-row { display: flex; align-items: center; gap: $s3; height: 40px; border-bottom: 1px solid ink.$line; padding: 0 $s2; }\n  &__skel-row .admin-panel__skel { margin: 0; }\n\n  &__tag {\n    display: inline-block;\n    margin-left: 6px;\n    padding: 1px $s2;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.5;\n    color: ink.$text-2;\n    background: rgba(255, 255, 255, 0.09);\n    border-radius: 10px;\n    white-space: nowrap;\n\n    &:first-child { margin-left: 0; }\n    &--danger { color: ink.$danger; background: rgba(217, 120, 109, 0.14); }\n    &--warn { color: var(--gold-light); background: rgba(255, 255, 255, 0.07); border: 1px solid var(--gold-dark); }\n  }\n\n  &__spill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 1px $s2;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.6;\n    white-space: nowrap;\n    border-radius: 10px;\n    color: ink.$success;\n    background: $tint-ok;\n\n    &--suspended { color: ink.$text-2; background: rgba(255, 255, 255, 0.09); }\n    &--expired { color: ink.$danger; background: $tint-danger; }\n  }\n\n  &__spill-dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }\n  &__spill-extra { font-weight: 400; opacity: 0.85; }\n\n  &__rolechip { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: ink.$text; white-space: nowrap; &--none { color: ink.$text-3; font-weight: 400; } }\n  &__swatch { display: inline-block; width: 10px; height: 10px; flex: none; border-radius: 50%; border: 1px solid ink.$line-strong; &--lg { width: 16px; height: 16px; } }\n\n  &__banner {\n    margin-bottom: $s3;\n    padding: $s2 $s3;\n    font-size: 13px;\n    line-height: 1.5;\n    color: ink.$text-2;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-left: 3px solid var(--gold-main);\n    border-radius: ink.$radius;\n    flex: none;\n  }\n\n  &__hint {\n    @include ink.hint;\n    margin: $s2 0 0;\n\n    &--warn { color: var(--gold-light); }\n    &--inline { margin: 0; flex: 1; }\n  }\n\n  &__foot-hint { @include ink.hint; margin-top: $s2; flex: none; }\n  &__counter { margin-top: $s1; text-align: right; font-size: 12px; color: ink.$text-3; }\n  &__sep { height: 1px; margin: $s5 0 $s4; background: ink.$line; }\n\n  // ---- toasts and modal ----------------------------------------------------\n\n  &__toasts {\n    position: absolute;\n    right: $s5;\n    bottom: $s5;\n    display: flex;\n    flex-direction: column;\n    gap: $s2;\n    max-width: 400px;\n    z-index: 70;\n  }\n\n  &__toast {\n    @include ink.panel;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: $s3;\n    padding: $s3 $s3 $s3 $s4;\n    font-size: 14px;\n    line-height: 1.4;\n    border-left: 3px solid ink.$text-3;\n    backdrop-filter: none;\n    animation: admin-panel-toast-in 0.2s $ease;\n\n    &--ok { border-left-color: ink.$success; }\n    &--err { border-left-color: ink.$danger; }\n    &--info { border-left-color: var(--gold-main); }\n  }\n\n  &__toast-close {\n    flex: none;\n    display: inline-flex;\n    padding: 2px;\n    color: ink.$text-3;\n    background: transparent;\n    border: 0;\n    border-radius: ink.$radius;\n    cursor: pointer;\n\n    &:hover { color: ink.$text; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 1px; }\n  }\n\n  &__modal-backdrop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.55);\n    z-index: 60;\n  }\n\n  &__modal {\n    @include ink.panel;\n    width: 480px;\n    max-width: 92%;\n    padding: $s5;\n    backdrop-filter: none;\n    animation: admin-panel-view-in 0.18s $ease;\n  }\n\n  &__modal-title { @include ink.title(20px); margin-bottom: $s3; }\n  &__modal-body { @include ink.lead; margin-bottom: $s5; word-wrap: break-word; }\n  &__modal-actions { display: flex; justify-content: flex-end; gap: $s2; }\n  &__quote { display: block; margin-top: $s2; padding: $s2 $s3; color: ink.$text; background: ink.$ink-field; border-radius: ink.$radius; white-space: pre-wrap; }\n\n  // ---- lists and tables ----------------------------------------------------\n\n  &__table {\n    display: flex;\n    flex-direction: column;\n    flex: 0 1 auto;\n    min-height: 0;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    overflow: hidden;\n  }\n\n  &__table-body { flex: 0 1 auto; min-height: 0; }\n  &__table--narrow { width: 100%; max-width: 860px; }\n\n  &__vlist {\n    @include ink.scroll;\n    position: relative;\n\n    &:focus { outline: none; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n  }\n\n  &__vrow {\n    position: absolute;\n    left: 0;\n    right: 0;\n    border-bottom: 1px solid ink.$line;\n    cursor: pointer;\n\n    &:hover { background: ink.$ink-raised; }\n    &[aria-selected='true'] { background: rgba(255, 255, 255, 0.06); }\n  }\n\n  &__prow {\n    display: grid;\n    grid-template-columns: 8px minmax(0, 1.6fr) 64px minmax(0, 1.4fr) 72px;\n    align-items: center;\n    gap: $s3;\n    height: 100%;\n    padding: 0 $s4;\n    border-left: 2px solid transparent;\n\n    &--head {\n      height: 32px;\n      font-size: 13px;\n      font-weight: 600;\n      color: ink.$text-3;\n      background: ink.$ink-raised;\n      border-bottom: 1px solid ink.$line;\n      flex: none;\n    }\n\n    &--selected { border-left-color: var(--gold-main); background: rgba(255, 255, 255, 0.07); }\n    &--offline .admin-panel__cell { color: ink.$text-3; }\n  }\n\n  &__num { text-align: right; font-variant-numeric: tabular-nums; }\n\n  &__lrow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: $s3;\n    height: 100%;\n    padding: 0 $s4;\n  }\n\n  &__stack { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n\n  &__dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    flex: none;\n    border-radius: 50%;\n    background: ink.$text-3;\n\n    &--online { background: ink.$success; }\n  }\n\n  &__cell {\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n\n    &--name { font-weight: 600; }\n    &--muted { color: ink.$text-2; font-size: 13px; }\n  }\n\n  &__cell--muted { color: ink.$text-2; font-size: 13px; }\n\n  // ---- players: table and drawer ------------------------------------------\n\n  &__players {\n    position: relative;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    padding: 0;\n\n    &--drawer { grid-template-columns: minmax(0, 1fr) $drawer-w; }\n  }\n\n  &__players-main {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    min-height: 0;\n    padding: $s5 $s5 $s4;\n  }\n\n  &__drawer {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    border-left: 1px solid ink.$line;\n    background: rgba(255, 255, 255, 0.025);\n    animation: admin-panel-slide-in 0.2s $ease both;\n  }\n\n  &__drawer-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: $s3;\n    padding: $s5 $s5 $s3;\n    border-bottom: 1px solid ink.$line;\n    flex: none;\n  }\n\n  &__drawer-id { min-width: 0; }\n  &__drawer-name { @include ink.title(22px); display: flex; align-items: center; gap: $s3; word-break: break-word; }\n  &__drawer-state { margin-top: $s2; font-size: 13px; color: ink.$text-2; }\n  &__drawer-scroll { @include ink.scroll; flex: 1; min-height: 0; padding: $s1 $s5 $s5; }\n\n  &__group { padding: $s4 0; border-bottom: 1px solid ink.$line; &:last-child { border-bottom: 0; } }\n  &__group-title { margin-bottom: $s3; font-size: 12px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: ink.$text-3; }\n\n  &__dl {\n    display: grid;\n    grid-template-columns: 112px minmax(0, 1fr);\n    gap: $s2 $s3;\n    font-size: 14px;\n\n    dt { color: ink.$text-3; }\n    dd { color: ink.$text; word-break: break-word; }\n\n    &--wide { grid-template-columns: 140px minmax(0, 1fr); }\n  }\n\n  &__wrap { word-break: break-all; font-size: 12px; }\n\n  &__gold { margin: $s3 0; }\n  &__gold-label { display: block; margin-bottom: $s2; @include ink.label; }\n  &__gold-row { display: flex; gap: $s2; align-items: center; .admin-panel__input { flex: 1; min-width: 0; } }\n\n  // ---- generic cards and stat blocks ---------------------------------------\n\n  &__card {\n    @include ink.block;\n    padding: $s4;\n\n    &--flat { margin-bottom: $s4; }\n  }\n\n  &__card--narrow { max-width: 720px; }\n  &__card-row { display: flex; align-items: center; justify-content: space-between; gap: $s4; flex-wrap: wrap; }\n  &__card-title { font-size: 16px; font-weight: 600; margin-bottom: $s1; }\n  &__cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: $s3; margin-bottom: $s2; }\n\n  &__status-label { @include ink.label; }\n\n  &__weather-now { @include ink.title(22px); margin-top: $s1; display: flex; align-items: center; gap: $s3; flex-wrap: wrap; }\n  &__weather-group { margin-top: $s4; }\n\n  &__stat-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: $s3; }\n\n  &__stat {\n    @include ink.block;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: $s1;\n    padding: $s4;\n    font-family: ink.$font-text;\n    text-align: left;\n    color: ink.$text;\n\n    &--link {\n      cursor: pointer;\n      transition: transform 0.14s $ease;\n\n      &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.08); border-color: var(--gold-dark); }\n      &:active:not(:disabled) { transform: scale(0.99); }\n      &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n      &:disabled { cursor: default; }\n    }\n\n    &--alert { border-color: var(--gold-main); }\n  }\n\n  &__stat-value { @include ink.title(28px); color: var(--gold-light); font-variant-numeric: tabular-nums; &--text { font-size: 22px; padding: $s1 0; word-break: break-word; } }\n  &__stat-note { font-size: 13px; color: ink.$text-3; }\n\n  &__mode-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: $s3; }\n\n  &__mode {\n    @include ink.button;\n    justify-content: space-between;\n    padding: $s4;\n    font-size: 15px;\n    text-align: left;\n    transition: transform 0.12s $ease;\n\n    &--active { border-color: var(--gold-main); .admin-panel__mode-state { color: var(--gold-light); } }\n  }\n\n  &__mode-state { font-size: 13px; font-weight: 600; color: ink.$text-3; }\n\n  &__mini-list { margin-bottom: $s2; }\n  &__mini-row {\n    display: grid;\n    grid-template-columns: 8px minmax(0, 1.3fr) minmax(0, 1fr) 64px;\n    align-items: center;\n    gap: $s3;\n    width: 100%;\n    padding: $s2;\n    font-family: ink.$font-text;\n    color: ink.$text;\n    text-align: left;\n    background: transparent;\n    border: 0;\n    border-bottom: 1px solid ink.$line;\n    cursor: pointer;\n\n    &:hover { background: ink.$ink-raised; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n  }\n\n  &__activity-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: $s4;\n    padding: $s2 $s1;\n    border-bottom: 1px solid ink.$line;\n    font-size: 14px;\n\n    &--err .admin-panel__activity-text { color: ink.$danger; }\n  }\n\n  &__report { list-style: none; display: block; &--done { opacity: 0.8; } }\n  &__report-head { display: flex; align-items: baseline; justify-content: space-between; gap: $s4; }\n  &__report-foot { display: flex; align-items: center; justify-content: space-between; gap: $s4; flex-wrap: wrap; padding-top: $s3; border-top: 1px solid ink.$line; }\n  &__report-where { flex: 1; min-width: 160px; }\n  &__templates { display: flex; flex-direction: column; gap: $s1; margin-bottom: $s2; }\n  &__template { width: 100%; padding: $s2 $s3; font-family: ink.$font-text; font-size: 14px; text-align: left; color: ink.$text-2; background: transparent; border: 1px solid ink.$line; border-radius: ink.$radius; cursor: pointer; &:hover { color: ink.$text; background: $tint-hover; border-color: var(--gold-dark); } &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; } }\n  &__copyline { display: flex; align-items: center; gap: $s2; span { min-width: 0; overflow-wrap: anywhere; } }\n  &__copybtn { display: inline-flex; flex: none; padding: $s1; color: ink.$text-2; background: transparent; border: 1px solid ink.$line; border-radius: ink.$radius; cursor: pointer; &:hover { color: ink.$text; border-color: var(--gold-dark); } &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; } }\n  &__report-text { margin: $s2 0 $s3; font-size: 15px; line-height: 1.5; white-space: pre-wrap; word-break: break-word; }\n\n  &__form { max-width: 720px; }\n  &__form-foot { display: flex; justify-content: flex-end; margin-top: $s1; }\n  &__form-actions { display: flex; justify-content: flex-end; margin-top: $s5; }\n\n  // ---- staff: sub-tabs, member list, editor --------------------------------\n\n  &__staff { overflow: hidden; }\n\n  &__subtabs {\n    display: flex;\n    gap: $s1;\n    margin-bottom: $s4;\n    border-bottom: 1px solid ink.$line;\n    flex: none;\n  }\n\n  &__subtab {\n    @include ink.tab;\n    padding: $s2 $s3;\n\n    &--active { @include ink.tab-active; }\n  }\n\n  &__subpanel { display: flex; flex-direction: column; flex: 1; min-height: 0; }\n\n  &__staffgrid {\n    display: flex;\n    gap: $s5;\n    flex: 1;\n    min-height: 0;\n  }\n\n  &__staffmain { @include ink.scroll; flex: 1; min-width: 0; min-height: 0; padding-right: $s2; }\n  &__staffgrid--editor &__cards--members { grid-template-columns: minmax(0, 1fr); }\n\n  &__cards--reports { grid-template-columns: minmax(0, 1fr); max-width: 900px; }\n  &__cards--members { grid-template-columns: repeat(auto-fill, minmax(380px, 1fr)); }\n  &__cards--roles { grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); }\n  &__staffgrid--editor &__cards--roles { grid-template-columns: minmax(0, 1fr); }\n\n  &__mcard {\n    position: relative;\n    display: flex;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n\n    &:hover { border-color: var(--gold-dark); }\n    &--active { border-color: var(--gold-main); background: rgba(255, 255, 255, 0.08); }\n    &--dim .admin-panel__mcard-body { opacity: 0.7; }\n  }\n\n  &__mcard-check { flex: none; width: 16px; height: 16px; margin: $s4 0 0 $s3; accent-color: var(--gold-main); cursor: pointer; }\n\n  &__mcard-body {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: $s2;\n    min-width: 0;\n    padding: $s3 $s4 $s3 $s3;\n    font-family: ink.$font-text;\n    text-align: left;\n    color: ink.$text;\n    background: transparent;\n    border: 0;\n    border-radius: ink.$radius;\n    cursor: pointer;\n\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n  }\n\n  &__mcard-top { display: flex; align-items: center; gap: $s2; }\n  &__mcard-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 16px; font-weight: 600; }\n  &__mcard-line { display: flex; align-items: center; flex-wrap: wrap; gap: $s2 $s3; }\n  &__mcard-meta { font-size: 13px; line-height: 1.4; color: ink.$text-3; word-break: break-word; }\n\n  &__rcard {\n    display: flex;\n    width: 100%;\n    padding: 0;\n    font-family: ink.$font-text;\n    text-align: left;\n    color: ink.$text;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    overflow: hidden;\n    cursor: pointer;\n\n    &:hover { border-color: var(--gold-dark); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n    &--active { border-color: var(--gold-main); background: rgba(255, 255, 255, 0.08); }\n  }\n\n  &__rcard-bar { flex: none; width: 6px; }\n  &__rcard-body { display: flex; flex-direction: column; gap: $s1; padding: $s3 $s4; min-width: 0; }\n  &__rcard-top { display: flex; align-items: center; gap: $s2; }\n  &__rcard-name { font-size: 16px; font-weight: 600; }\n  &__rcard-desc { font-size: 13px; line-height: 1.4; color: ink.$text-2; }\n  &__rcard-meta { font-size: 13px; color: ink.$text-3; }\n\n  &__bulkbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: $s2 $s3;\n    margin-bottom: $s3;\n    padding: $s2 $s3;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid var(--gold-dark);\n    border-radius: ink.$radius;\n    animation: admin-panel-view-in 0.16s $ease;\n  }\n\n  &__bulkcount { font-size: 14px; font-weight: 600; color: var(--gold-light); }\n  &__bulkgroup { display: inline-flex; align-items: center; gap: $s2; }\n\n  &__tablewrap { overflow-x: auto; border: 1px solid ink.$line; border-radius: ink.$radius; }\n\n  &__dtable {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n\n    th {\n      padding: $s2 $s3;\n      font-size: 13px;\n      font-weight: 600;\n      text-align: left;\n      color: ink.$text-3;\n      white-space: nowrap;\n      background: ink.$ink-raised;\n      border-bottom: 1px solid ink.$line;\n    }\n\n    td { padding: $s2 $s3; vertical-align: middle; border-bottom: 1px solid ink.$line; }\n    tbody tr { cursor: pointer; }\n    tbody tr:hover { background: ink.$ink-raised; }\n    tbody tr.is-active { background: rgba(255, 255, 255, 0.08); box-shadow: inset 2px 0 0 var(--gold-main); }\n    tbody tr.is-dim td { opacity: 0.7; }\n    .admin-panel__num { text-align: right; }\n  }\n\n  &__staffgrid--editor &__col-hide { display: none; }\n  &__col-check { width: 36px; }\n\n  &__rowlink {\n    display: inline-flex;\n    align-items: center;\n    gap: $s2;\n    padding: 0;\n    font-family: ink.$font-text;\n    font-size: 14px;\n    font-weight: 600;\n    color: ink.$text;\n    background: transparent;\n    border: 0;\n    cursor: pointer;\n\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n  }\n\n  &__owners { margin-top: $s2; }\n  &__owner { display: flex; align-items: center; gap: $s3; padding: $s2 $s1; border-bottom: 1px solid ink.$line; }\n\n  // The editor: a side sheet, sections separated by thin rules rather than cards\n  &__editor {\n    display: flex;\n    flex-direction: column;\n    flex: none;\n    width: $editor-w;\n    min-height: 0;\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n    background: rgba(255, 255, 255, 0.03);\n    animation: admin-panel-slide-in 0.2s $ease both;\n  }\n\n  &__editor-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: $s3;\n    padding: $s4 $s5 $s3;\n    border-bottom: 1px solid ink.$line;\n    flex: none;\n  }\n\n  &__editor-id { min-width: 0; }\n  &__editor-title { @include ink.title(20px); word-break: break-word; }\n  &__editor-sub { display: flex; align-items: center; flex-wrap: wrap; gap: $s2 $s3; margin-top: $s2; }\n  &__editor-scroll { @include ink.scroll; flex: 1; min-height: 0; padding: 0 $s5 $s4; }\n\n  &__editor-foot {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: $s3;\n    padding: $s3 $s5;\n    border-top: 1px solid ink.$line;\n    flex: none;\n  }\n\n  &__editor-save { display: flex; align-items: center; gap: $s3; }\n  &__dirty { font-size: 13px; color: var(--gold-light); }\n\n  &__esec { padding: $s4 0; border-bottom: 1px solid ink.$line; &:last-child { border-bottom: 0; } }\n  &__esec-title { margin-bottom: $s1; font-size: 12px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: ink.$text-3; }\n\n  &__switchrow { display: flex; align-items: center; justify-content: space-between; gap: $s4; margin-top: $s2; }\n  &__expiry { display: flex; flex-wrap: wrap; align-items: center; gap: $s2; }\n  &__expiry .admin-panel__chip { margin: 0; }\n  &__rolepick { display: flex; align-items: center; gap: $s3; }\n\n  &__candidates { display: flex; flex-direction: column; gap: $s1; margin-top: $s3; max-height: 300px; overflow-y: auto; }\n\n  &__candidate {\n    display: flex;\n    align-items: center;\n    gap: $s3;\n    width: 100%;\n    padding: $s2 $s3;\n    font-family: ink.$font-text;\n    color: ink.$text;\n    text-align: left;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    cursor: pointer;\n\n    &:hover { background: rgba(255, 255, 255, 0.09); border-color: var(--gold-dark); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n  }\n\n  &__matrix { margin: $s3 0 $s2; border: 1px solid ink.$line; border-radius: ink.$radius; }\n\n  &__matrix-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: $s3;\n    padding: $s3;\n    border-bottom: 1px solid ink.$line;\n\n    &:last-child { border-bottom: 0; }\n    &--on { background: rgba(255, 255, 255, 0.04); }\n  }\n\n  &__matrix-text { flex: 1; min-width: 0; }\n  &__matrix-label { font-size: 14px; font-weight: 600; }\n  &__matrix-desc { margin-top: 2px; font-size: 12px; line-height: 1.4; color: ink.$text-3; }\n\n  &__tri { display: inline-flex; flex: none; border: 1px solid ink.$line-strong; border-radius: ink.$radius; overflow: hidden; }\n\n  &__tri-opt {\n    padding: 5px $s2;\n    font-family: ink.$font-text;\n    font-size: 12px;\n    font-weight: 600;\n    color: ink.$text-2;\n    background: transparent;\n    border: 0;\n    border-right: 1px solid ink.$line;\n    cursor: pointer;\n\n    &:last-child { border-right: 0; }\n    &:hover:not(:disabled):not(.admin-panel__tri-opt--on) { color: ink.$text; background: $tint-hover; }\n    &:disabled { opacity: 0.35; cursor: not-allowed; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n    &--on { color: ink.$text; background: $tint-active; }\n    &--add#{&}--on { color: ink.$success; background: $tint-ok; }\n    &--deny#{&}--on { color: ink.$danger; background: $tint-danger; }\n  }\n\n  &__final {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n    width: 24px;\n    height: 24px;\n    color: ink.$text-3;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n\n    &--on { color: ink.$success; border-color: ink.$success; background: $tint-ok; }\n  }\n\n  &__previewline { display: flex; align-items: flex-start; gap: $s3; margin-top: $s3; }\n  &__previewlabel { flex: none; width: 56px; padding-top: 2px; font-size: 13px; color: ink.$text-3; }\n  &__chipline { display: flex; flex-wrap: wrap; gap: $s1 $s1; }\n  &__chipline .admin-panel__tag { margin-left: 0; }\n\n  &__palette { display: flex; flex-wrap: wrap; gap: $s2; }\n\n  &__colorbtn {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: 2px solid transparent;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: transform 0.12s $ease;\n\n    &:hover { transform: scale(1.08); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n    &--on { border-color: ink.$text; }\n  }\n\n  // ---- timeline (journal) --------------------------------------------------\n\n  &__timeline { position: relative; margin-top: $s3; }\n  &__tl-item { position: relative; display: flex; gap: $s3; padding: 0 0 $s4 $s5; }\n  &__tl-item::before { content: ''; position: absolute; top: 12px; bottom: -4px; left: 4px; width: 1px; background: ink.$line-strong; }\n  &__tl-item:last-child::before { display: none; }\n  &__tl-dot { position: absolute; top: 5px; left: 0; width: 9px; height: 9px; border-radius: 50%; background: ink.$text-3; &--member { background: var(--gold-main); } &--role { background: ink.$success; } &--bulk { background: ink.$danger; } }\n  &__tl-main { min-width: 0; }\n  &__tl-title { font-size: 14px; font-weight: 600; }\n  &__tl-target { margin-left: $s2; font-weight: 400; color: var(--gold-light); }\n  &__tl-detail { margin-top: 2px; font-size: 14px; line-height: 1.45; color: ink.$text-2; }\n  &__tl-meta { margin-top: 2px; font-size: 12px; color: ink.$text-3; }\n  &__timeline--small { margin-top: $s2; }\n  &__timeline--small &__tl-item { padding-bottom: $s3; }\n\n  // ---- matrix of the whole staff -------------------------------------------\n\n  &__matrixtab, &__audittab, &__toolstab { @include ink.scroll; flex: 1; min-height: 0; padding-right: $s2; }\n\n  &__legend { display: flex; flex-wrap: wrap; gap: $s3; font-size: 13px; color: ink.$text-2; li { display: inline-flex; align-items: center; gap: 6px; } }\n\n  &__tablewrap--matrix { margin-top: $s3; }\n\n  &__mtable {\n    border-collapse: separate;\n    border-spacing: 0;\n    width: 100%;\n    font-size: 13px;\n\n    th, td { padding: $s2; text-align: center; border-bottom: 1px solid ink.$line; white-space: nowrap; }\n    thead th { position: sticky; top: 0; z-index: 2; font-weight: 600; color: ink.$text-2; background: rgba(20, 24, 29, 1); }\n    tr.is-dim td, tr.is-dim th { opacity: 0.55; }\n    tbody tr:hover td, tbody tr:hover th { background: ink.$ink-raised; }\n    tfoot th, tfoot td { font-weight: 600; background: rgba(20, 24, 29, 1); border-bottom: 0; }\n  }\n\n  &__mtable-first { position: sticky; left: 0; z-index: 1; min-width: 220px; text-align: left !important; background: rgba(15, 19, 24, 1); }\n  &__mtable thead &__mtable-first { z-index: 3; background: rgba(20, 24, 29, 1); }\n  &__mname { display: block; margin-bottom: 2px; font-size: 14px; font-weight: 600; color: ink.$text; }\n  &__mtable-total { font-variant-numeric: tabular-nums; color: var(--gold-light); }\n\n  &__mx {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    color: ink.$text-3;\n    background: transparent;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: transform 0.1s $ease;\n\n    &:hover { border-color: var(--gold-main); }\n    &:active { transform: scale(0.9); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n    &--inherit-on { color: var(--gold-light); border-color: var(--gold-dark); }\n    &--add { color: ink.$on-accent; background: var(--gold-main); border-color: var(--gold-main); }\n    &--deny { color: ink.$danger; border-color: ink.$danger; background: $tint-danger; }\n  }\n\n  // ---- tools ---------------------------------------------------------------\n\n  &__tool { max-width: 860px; padding-bottom: $s5; margin-bottom: $s5; border-bottom: 1px solid ink.$line; &:last-child { border-bottom: 0; } }\n  &__tool-title { @include ink.title(18px); margin-bottom: $s1; }\n  &__code { min-height: 140px; margin: $s3 0; font-family: Consolas, 'Courier New', monospace; font-size: 12px; line-height: 1.5; resize: vertical; white-space: pre; }\n  &__importsum { display: flex; flex-wrap: wrap; gap: $s2; margin: $s3 0; }\n  &__importlist { max-height: 240px; margin-bottom: $s3; overflow-y: auto; border: 1px solid ink.$line; border-radius: ink.$radius; }\n  &__importline { display: flex; gap: $s3; padding: $s2 $s3; font-size: 13px; border-bottom: 1px solid ink.$line; &:last-child { border-bottom: 0; } &--error { color: ink.$danger; } &--same { color: ink.$text-3; } }\n  &__importkind { flex: none; width: 88px; font-weight: 600; }\n\n  // ---- legacy classes (PlacementTab, SpawnTab, TimeControls) ---------------\n\n  &__body { display: flex; flex-direction: column; min-height: 0; flex: 1; }\n  &__filters { display: flex; align-items: center; gap: $s3; margin-bottom: $s3; }\n\n  &__online-toggle {\n    display: flex;\n    align-items: center;\n    gap: $s2;\n    flex: none;\n    white-space: nowrap;\n    color: ink.$text-2;\n    font-size: 14px;\n    cursor: pointer;\n    user-select: none;\n\n    input { width: 16px; height: 16px; accent-color: var(--gold-main); cursor: pointer; }\n  }\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: $s3;\n    padding: $s2 $s3;\n    border-bottom: 1px solid ink.$line;\n\n    &--head { padding-top: $s1; padding-bottom: $s2; color: ink.$text-3; font-size: 13px; font-weight: 600; }\n    &--location { justify-content: space-between; }\n    &--offline { color: ink.$text-3; }\n  }\n\n  &__cell--discord-id { color: ink.$text-2; }\n  &__list { @include ink.scroll; flex: 1; min-height: 0; }\n  &__empty { padding: $s5 0; color: ink.$text-3; font-size: 14px; }\n\n  &__time { margin-bottom: $s4; padding: $s3 $s4; border: 1px solid ink.$line; border-radius: ink.$radius; background: ink.$ink-raised; }\n  &__time-head { display: flex; align-items: center; justify-content: space-between; gap: $s3; margin-bottom: $s3; }\n  &__time-clock { font-size: 30px; font-weight: 600; letter-spacing: 1px; font-variant-numeric: tabular-nums; }\n  &__time-note { color: ink.$text-3; font-size: 13px; }\n  &__time-row { display: flex; flex-wrap: wrap; align-items: center; gap: $s2; margin-top: $s2; }\n  &__time-sep { flex: 1; }\n  &__time-input { @include ink.field; width: 64px; text-align: center; }\n\n  &__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: $s3; }\n\n  &__chip {\n    @include ink.button;\n    @include ink.button-sm;\n    padding: 5px $s3;\n    transition: transform 0.12s $ease;\n\n    &--active, &[aria-pressed='true'] { @include ink.button-primary; }\n  }\n\n  &__search { @include ink.field; flex: 1; width: auto; }\n  &__badge { @include ink.badge; margin-right: 2px; }\n}\n\n// ---- narrower windows --------------------------------------------------------\n\n@media (max-width: 1500px) {\n  .admin-panel__updated { display: none; }\n}\n\n@media (max-width: 1280px) {\n  .admin-panel__pill--uptime { display: none; }\n  .admin-panel__brand { width: auto; }\n  .admin-panel__window { grid-template-columns: 220px minmax(0, 1fr); }\n  .admin-panel__nav { gap: $s2; }\n  .admin-panel__players--drawer { grid-template-columns: minmax(0, 1fr) 360px; }\n  .admin-panel__editor { width: 440px; }\n}\n\n// Small screens: the window takes the whole screen, the rail becomes a strip\n@media (max-width: 900px), (max-height: 560px) {\n  .admin-panel__window {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    border: 0;\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: auto auto minmax(0, 1fr);\n  }\n\n  .admin-panel__top { flex-wrap: wrap; gap: $s2 $s3; padding: $s3; }\n  .admin-panel__brand { order: 1; padding-left: 0; }\n  .admin-panel__top-actions { order: 2; margin-left: auto; }\n  .admin-panel__gsearch { order: 3; flex: 1 1 100%; max-width: none; }\n  .admin-panel__pills { order: 4; flex-wrap: wrap; }\n  .admin-panel__pill:first-child { padding-left: 0; }\n\n  .admin-panel__rail {\n    display: flex;\n    gap: $s4;\n    padding: $s2 $s3;\n    overflow-x: auto;\n    overflow-y: hidden;\n    border-right: 0;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  .admin-panel__rail-group { display: flex; align-items: center; gap: $s1; margin: 0; flex: none; }\n  .admin-panel__rail-title { display: none; }\n  .admin-panel__nav { width: auto; height: 34px; margin: 0; white-space: nowrap; border-left-width: 1px; }\n  .admin-panel__nav--active { border-bottom: 2px solid var(--gold-main); }\n\n  .admin-panel__view { padding: $s4 $s3 $s3; }\n  .admin-panel__players-main { padding: $s4 $s3 $s3; }\n  .admin-panel__players--drawer { grid-template-columns: minmax(0, 1fr); }\n  .admin-panel__drawer { position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; background: rgba(11, 15, 19, 0.99); border-left: 0; }\n  .admin-panel__columns { grid-template-columns: minmax(0, 1fr); }\n  .admin-panel__staffgrid { flex-direction: column; overflow-y: auto; }\n  .admin-panel__staffmain { overflow: visible; flex: none; padding-right: 0; }\n  .admin-panel__staffgrid--editor .admin-panel__staffmain { display: none; }\n  .admin-panel__editor { width: 100%; flex: 1; }\n  .admin-panel__cards, .admin-panel__cards--members, .admin-panel__cards--roles { grid-template-columns: minmax(0, 1fr); }\n  .admin-panel__toasts { right: $s3; bottom: $s3; left: $s3; max-width: none; }\n  .admin-panel__subtabs { overflow-x: auto; }\n}\n\n// ---- compact density ---------------------------------------------------------\n\n.admin-panel--compact {\n  .admin-panel__nav { height: 32px; font-size: 14px; }\n  .admin-panel__rail-group { margin-bottom: $s3; }\n  .admin-panel__view { padding-top: $s4; }\n  .admin-panel__view-head { margin-bottom: $s3; }\n  .admin-panel__players-main { padding-top: $s4; }\n  .admin-panel__group { padding: $s3 0; }\n  .admin-panel__mcard-body { gap: $s1; padding-top: $s2; padding-bottom: $s2; }\n  .admin-panel__dtable td { padding-top: $s1; padding-bottom: $s1; }\n  .admin-panel__matrix-row { padding-top: $s2; padding-bottom: $s2; }\n  .admin-panel__stat { padding: $s3; }\n  .admin-panel__esec { padding: $s3 0; }\n}\n\n// ---- reduced motion: everything is instant ------------------------------------\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-panel,\n  .admin-panel * {\n    animation: none !important;\n    transition: none !important;\n  }\n\n  .admin-panel__window { transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
